export const translations = {
  pl: {
    // === GLOBAL ===
    loading: 'Ładowanie...',
    cancel: 'Anuluj',
    save: 'Zapisz',
    close: 'Zamknij',
    send: 'Wyślij',
    delete: 'Usuń',
    edit: 'Edytuj',
    back: 'Wróć',

    // === AUTH — Login ===
    'login.title': 'Logowanie',
    'login.username': 'Email',
    'login.password': 'Hasło',
    'login.submit': 'Zaloguj',
    'login.no_account': 'Nie masz konta?',
    'login.register_link': 'Zarejestruj się',
    'login.forgot': 'Zapomniałem hasła',
    'login.success': 'Zalogowano!',
    'login.error': 'Nieprawidłowe dane logowania',

    // === AUTH — Register ===
    'register.title': 'Rejestracja',
    'register.name': 'Imię i nazwisko',
    'register.email': 'Email',
    'register.password': 'Hasło',
    'register.confirm_password': 'Potwierdź hasło',
    'register.submit': 'Zarejestruj',
    'register.has_account': 'Masz już konto?',
    'register.login_link': 'Zaloguj się',
    'register.success': 'Rejestracja udana! Możesz się zalogować.',
    'register.error': 'Rejestracja nie powiodła się.',
    'register.passwords_mismatch': 'Hasła nie są identyczne',

    // === AUTH — Reset password ===
    'reset.title': 'Reset hasła',
    'reset.intro': 'Podaj adres email powiązany z Twoim kontem. Wyślemy na niego 6-cyfrowy kod.',
    'reset.email_label': 'Adres email',
    'reset.email_placeholder': 'twoj@email.pl',
    'reset.sending': 'Wysyłam...',
    'reset.send_code': 'Wyślij kod',
    'reset.code_sent': 'Kod wysłany na',
    'reset.code_label': 'Kod z emaila (6 cyfr)',
    'reset.new_password': 'Nowe hasło',
    'reset.confirm_password': 'Potwierdź nowe hasło',
    'reset.confirm_placeholder': 'powtórz hasło',
    'reset.min_chars': 'min. 6 znaków',
    'reset.changing': 'Zmieniam...',
    'reset.change': 'Zmień hasło',
    'reset.resend': 'Wyślij kod ponownie',
    'reset.success': 'Hasło zmienione — jesteś zalogowany!',
    'reset.passwords_mismatch': 'Hasła nie są identyczne',
    'reset.too_short': 'Hasło musi mieć co najmniej 6 znaków',
    'reset.error_email': 'Błąd wysyłania emaila',
    'reset.error_code': 'Błąd weryfikacji kodu',

    // === HEADER ===
    'header.help': 'Jak zacząć?',
    'header.admin': 'Admin',
    'header.login': 'Zaloguj',
    'header.register': 'Zarejestruj',
    'header.logout_success': 'Wylogowano!',

    // === Konto ===
    'account.title': 'Moje konto',
    'account.username': 'Nazwa użytkownika',
    'account.email': 'Email',
    'account.logout': 'Wyloguj',
    'account.danger_title': 'Strefa niebezpieczna',
    'account.delete_desc': 'Trwale usuń konto wraz ze wszystkimi zapisanymi przepisami. Tej operacji nie można cofnąć.',
    'account.delete_btn': 'Usuń konto',
    'account.delete_warn': 'Tej operacji nie można cofnąć. Wszystkie Twoje dane i zapisane przepisy zostaną trwale usunięte.',
    'account.delete_password_label': 'Potwierdź hasłem',
    'account.delete_confirm_btn': 'Usuń konto na zawsze',
    'account.deleting': 'Usuwanie...',
    'account.deleted': 'Twoje konto zostało usunięte.',
    'account.delete_error': 'Nie udało się usunąć konta.',

    // === HERO ===
    'hero.title': 'Konwerter przepisów Monsieur Cuisine',
    'hero.sub': 'Wklej swój przepis, a AI przekonwertuje go na format MC Smart — z temperaturami, czasami i prędkościami. Gotowy przepis wyślesz jednym kliknięciem na swoje konto.',
    'hero.feat1': 'Wklej własny przepis',
    'hero.feat2': 'AI skonwertuje na MC',
    'hero.feat3': 'Wyślij na konto MC',
    'hero.cta_login': 'Zaloguj się i zacznij',
    'hero.cta_help': 'Jak to działa?',

    // === FOOTER ===
    'footer.tagline': 'Konwerter przepisów Monsieur Cuisine Smart',
    'footer.help': 'Pomoc',
    'footer.contact': 'Kontakt',
    'footer.privacy': 'Polityka prywatności',
    'footer.android': 'Aplikacja Android',
    'app_update.text': 'Jest nowa wersja aplikacji Matemeal ({v}). Pobierz i zainstaluj ją na obecną — bez odinstalowywania.',
    'app_update.cta': 'Pobierz',
    'footer.security': 'Bezpieczeństwo:',
    'footer.security_text': 'Przepisy generowane są przez AI. Zawsze sprawdź parametry przed uruchomieniem na urządzeniu. Autor nie ponosi odpowiedzialności za ewentualne szkody.',
    'footer.affiliate': 'Affiliate disclaimer:',
    'footer.affiliate_text': 'Aplikacja zawiera linki partnerskie wspierające rozwój projektu.',
    'footer.rights': 'Wszelkie prawa zastrzeżone.',

    // === CONTACT MODAL ===
    'contact.tab_contact': 'Kontakt',
    'contact.tab_bug': 'Zgłoś błąd',
    'contact.intro_bug': 'Znalazłeś błąd? Opisz go poniżej.',
    'contact.intro_contact': 'Masz pytanie lub sugestię? Napisz do nas.',
    'contact.topic': 'Temat',
    'contact.email': 'Twój e-mail',
    'contact.email_optional': '(opcjonalnie)',
    'contact.message': 'Wiadomość',
    'contact.send': 'Wyślij',
    'contact.sent_title': 'Wiadomość wysłana!',
    'contact.sent_text': 'Odezwiemy się wkrótce.',
    'contact.bug_topic': 'Zgłoszenie błędu',
    'contact.generic_topic': 'Wiadomość',

    // === RECIPE CONVERTER ===
    'conv.title': 'Konwerter przepisów Monsieur Cuisine',
    'conv.title_short': 'Konwerter',
    'conv.sub': 'Wklej swój przepis — AI przekonwertuje go na format MC Smart',
    'conv.mc_connected': 'Połączono z Monsieur Cuisine',
    'conv.mc_locale_title': 'Wersja językowa konta MC (gdzie mają trafiać przepisy)',
    'conv.mc_connected_mobile': 'Konto MC połączone',
    'conv.mobile_no_session': 'Konwerter działa na telefonie. Wysyłanie przepisów na MC dostępne tylko na komputerze z rozszerzeniem Chrome.',
    'conv.mobile_hint': 'Na telefonie: skonwertuj przepis, skopiuj jako Tekst i wklej ręcznie w aplikacji MC — lub użyj komputera żeby wysłać jednym kliknięciem.',
    'conv.install_ext': 'Aby wysyłać przepisy na konto MC — zainstaluj rozszerzenie',
    'conv.url_label': 'Masz link do swojego przepisu? Zaimportuj go z adresu URL',
    'conv.url_placeholder': 'np. https://...',
    'conv.url_btn': 'Importuj',
    'conv.url_loading': 'Pobieram...',
    'conv.url_error': 'Nie udało się zaimportować przepisu z tego adresu',
    'conv.url_ok': 'Przepis zaimportowany — sprawdź tekst poniżej i kliknij Konwertuj',
    'conv.image_label': 'Masz przepis na zdjęciu lub screenshocie? Wczytaj go',
    'conv.image_btn': 'Wgraj zdjęcie / screenshot',
    'conv.image_loading': 'Odczytuję tekst...',
    'conv.image_hint': 'Możesz też wkleić zrzut ekranu (Ctrl+V) w pole poniżej.',
    'conv.image_ok': 'Tekst odczytany — sprawdź go poniżej i kliknij Konwertuj',
    'conv.image_err': 'Nie udało się odczytać tekstu ze zdjęcia',
    'conv.dish_btn': 'Dodaj zdjęcie potrawy',
    'conv.dish_loading': 'Wysyłam zdjęcie...',
    'conv.dish_ok': 'Zdjęcie gotowe — trafi na MC razem z przepisem',
    'conv.dish_remove': 'Usuń',
    'conv.dish_hint': 'Opcjonalnie. Zdjęcie będzie miniaturą przepisu na Twoim koncie MC.',
    'conv.dish_err': 'Nie udało się wysłać zdjęcia — przepis wyślemy bez miniatury',
    'conv.bg_waiting': 'Wysyłam na MC — możesz zamknąć stronę, dam znać po powrocie:',
    'conv.bg_done': 'Gotowe na MC:',
    'conv.paste_label': 'Wklej przepis w dowolnej formie',
    'conv.paste_placeholder': `Wklej swój przepis lub napisz go własnymi słowami...

np.
'Pomidorowa z bazylią
1 cebula, 2 ząbki czosnku, 500g pomidorów z puszki, 500ml bulionu
Cebulę i czosnek zeszklić na oliwie. Dodać pomidory, bulion, gotować 20 min. Zmiksować. Dodać bazylię.'`,
    'conv.limit_exhausted': 'Limit wyczerpany',
    'conv.limit_renews': 'odnowi się',
    'conv.limit_usage': 'konwersji w tym miesiącu',
    'conv.limit_left': 'pozostało',
    'conv.converting': 'Konwertuję...',
    'conv.convert_btn': 'Konwertuj na format MC',
    'conv.reset': 'Zacznij od nowa',
    'conv.warning': 'Zawsze sprawdź przepis przed użyciem na urządzeniu.',
    'conv.audit_fixed': 'Audyt przepisu: poprawiono automatycznie {n}',
    'conv.error_empty': 'Wklej przepis przed konwersją.',
    'conv.error_conv': 'Błąd konwersji',
    'conv.error_net': 'Błąd sieci',
    'conv.error_ext': 'Brak potwierdzenia z rozszerzenia — przepis mógł mimo to trafić na MC. Sprawdź „Moje przepisy" na monsieur-cuisine.com, zanim wyślesz ponownie.',
    'conv.error_send': 'Błąd wysyłania do MC.',
    'conv.checking_mc': 'Rozszerzenie przekroczyło czas, ale MC bywa wolne — sprawdzam, czy przepis mimo to powstał. Nie zamykaj strony.',
    'conv.checking_srv': 'Wysyłka trwa — serwery Monsieur Cuisine tworzą przepis ok. 2 minut. Pilnujemy tego za Ciebie: możesz zamknąć stronę, link będzie czekał po powrocie.',
    'conv.checking_mc_btn': 'Sprawdzam MC…',
    'conv.recovered': 'Wysłano! Rozszerzenie zgłosiło przekroczenie czasu, ale przepis jest na Twoim koncie MC.',
    'conv.error_no_mc_session': 'Konto MC niepołączone. Zaloguj się na monsieur-cuisine.com na komputerze z zainstalowanym rozszerzeniem Chrome.',
    'conv.error_mc_session_expired': 'Sesja Monsieur Cuisine wygasła. Zaloguj się ponownie na monsieur-cuisine.com i spróbuj wysłać przepis jeszcze raz.',
    'conv.error_no_extension': 'Nie wykryto rozszerzenia Chrome „Matemeal Connector" ani połączenia z kontem MC — nie mamy jak wysłać przepisu. Zainstaluj rozszerzenie albo połącz konto MC.',
    'conv.error_save': 'Błąd zapisywania',
    'conv.error_load': 'Błąd wczytywania przepisu',
    'conv.saved_mc': 'Przepis zapisany na koncie MC!',
    'conv.sent_excl': 'Wysłano!',
    'conv.sent_draft': 'Wysłano na MC jako szkic — dodaj zdjęcie potrawy na MC, żeby opublikować.',
    'conv.open_mc': 'Otwórz przepis na MC',
    'conv.save': 'Zapisz przepis',
    'conv.save_ok': 'Przepis zapisany w przepiśniku!',
    'conv.export_json': 'Eksportuj przepis',
    'conv.import_json': 'Importuj przepis',
    'conv.import_json_ok': 'Przepis wczytany z pliku!',
    'conv.import_json_err': 'To nie jest plik przepisu matemeal — sprawdź czy to prawidłowy eksport.',
    'conv.export_native_err': 'Nie udało się zapisać pliku. Spróbuj ponownie.',
    'conv.json_import_label': 'Wgraj plik przepisu',
    'conv.json_import_hint': 'Wczytuje przepis wyeksportowany wcześniej z matemeal (📖 plik .mtmeal) — bez AI, od razu gotowy do edycji lub wysyłki.',
    'conv.repair_hint': 'Opcjonalnie: zaznacz krok z błędem (checkbox), opisz problem i kliknij "Popraw przepis". Kroki z ikoną ⚖️ to ważenie na wadze MC — nie mają parametrów maszyny.',
    'conv.repair_placeholder': 'Opisz co jest nie tak. Np. "W kroku 4 brakuje prędkości i czasu" lub "Krok 3 powinien być miksowaniem na pręd. 5 przez 30s"',
    'conv.repair_btn': 'Popraw przepis',
    'conv.repairing': 'Poprawiam...',
    'conv.repair_ok': 'Przepis poprawiony!',
    'conv.repair_answer_placeholder': 'Twoja odpowiedź...',
    'conv.repair_send': 'Odpowiedz',
    'conv.repair_cancel': 'Anuluj',
    'conv.repair_save_ask': 'Zapisać poprawioną wersję?',
    'conv.repair_save_yes': 'Tak, zapisz (zastąp poprzednią)',
    'conv.repair_save_no': 'Nie, pomiń',
    'conv.step_weigh': 'Ważenie MC',
    'conv.step_manual': 'Ręcznie',
    'conv.empty_hint1': 'Wklej przepis i kliknij',
    'conv.empty_hint2': '„Konwertuj na format MC"',
    'conv.empty_hint3': 'AI dostosuje przepis do urządzenia MC Smart — doda temperatury, czasy i prędkości.',
    'conv.empty_mc_note': 'Aby wysyłać przepisy na konto MC, zainstaluj rozszerzenie Chrome i zaloguj się na monsieur-cuisine.com.',
    'conv.mc_connect_note': 'Aby wysyłać przepisy na konto MC, połącz aplikację ze swoim kontem Monsieur Cuisine.',
    'conv.mc_connect_btn': 'Połącz z Monsieur Cuisine',
    'conv.mc_connect_hint': 'Zaloguj się na swoje konto Monsieur Cuisine — aplikacja połączy się automatycznie.',
    'conv.mobile_no_session@app': 'Konto MC niepołączone — użyj przycisku „Połącz z Monsieur Cuisine”, aby wysyłać przepisy prosto z aplikacji.',
    'conv.image_hint@app': 'Możesz też zrobić zdjęcie przepisu aparatem — rozpoznany tekst trafi do pola poniżej.',
    'conv.error_ext@app': 'Brak potwierdzenia wysyłki — przepis mógł mimo to trafić na MC. Sprawdź „Moje przepisy” na monsieur-cuisine.com, zanim wyślesz ponownie.',
    'conv.error_no_mc_session@app': 'Konto MC niepołączone. Kliknij „Połącz z Monsieur Cuisine” w konwerterze i zaloguj się na swoje konto.',
    'conv.error_mc_session_expired@app': 'Sesja Monsieur Cuisine wygasła. Kliknij „Połącz z Monsieur Cuisine”, zaloguj się ponownie i wyślij przepis jeszcze raz.',
    'help.start.s3.desc_a@app': 'Połącz konto Monsieur Cuisine (zakładka',
    'help.start.s3.desc_tab@app': 'Połączenie z MC',
    'help.start.s3.desc_b@app': '), a potem kliknij',
    'help.start.alert@app': 'Konto MC łączysz bezpośrednio w aplikacji — zobacz zakładkę „Połączenie z MC”. Bez rozszerzeń i bez komputera.',
    'help.conv.l1@app': 'Skopiuj cały tekst swojego przepisu',
    'help.conv.l2@app': 'Wklej go w pole konwertera — albo zrób zdjęcie przepisu aparatem',
    'help.conv.h4@app': 'Zapis i wysyłka',
    'help.conv.share.l2_b@app': '— połącz konto w zakładce „Połączenie z MC”',
    'help.conv.share.l3@app': 'Połączenie robisz raz — potem wysyłasz przepisy jednym kliknięciem',
    'help.prob.h1@app': 'Problemy z połączeniem MC',
    'help.prob.p3.l1@app': 'Kliknij „Połącz z Monsieur Cuisine” w konwerterze i zaloguj się ponownie',
    'help.prob.p3.l2@app': 'Wysyłka będzie znów aktywna — aplikacja odświeża sesję w tle',
    'help.prob.p9.q@app': 'Mogę konwertować przepisy bez konta MC?',
    'help.prob.p9.desc@app': 'Konto MateMeal jest wymagane do konwersji. Do wysyłania przepisów połącz konto Monsieur Cuisine w aplikacji (zakładka „Połączenie z MC”).',
    'conv.image_camera': 'Zrób zdjęcie',
    'help.tab.app': 'Połączenie z MC',
    'help.app.lead': 'W aplikacji nie potrzebujesz rozszerzenia Chrome — konto Monsieur Cuisine łączysz bezpośrednio w apce.',
    'help.app.alert': 'Połączenie robisz tylko raz. Aplikacja sama odświeża sesję w tle.',
    'help.app.h1': 'Jak połączyć konto MC',
    'help.app.s1.title': 'Zaloguj się do Matemeal',
    'help.app.s1.desc': 'Użyj swojego zwykłego konta Matemeal — tego samego co na stronie.',
    'help.app.s2.title': 'Kliknij „Połącz z Monsieur Cuisine”',
    'help.app.s2.desc': 'Przycisk znajdziesz w konwerterze. Otworzy się okno logowania Monsieur Cuisine (konto Lidl).',
    'help.app.s3.title': 'Zaloguj się na konto MC',
    'help.app.s3.desc': 'Po udanym logowaniu okno zamknie się samo i wysyłka przepisów będzie aktywna.',
    'help.app.note': 'Wysyłka przepisu na konto MC trwa zwykle około 2 minut — w tym czasie możesz normalnie korzystać z aplikacji.',
    'help.app.sec.l1': 'Dane logowania Lidl wpisujesz wyłącznie na stronie Monsieur Cuisine — aplikacja ich nie widzi i nie zapisuje.',
    'help.app.sec.l2': 'Aplikacja przechowuje tylko sesję (ciasteczka), dokładnie tak jak przeglądarka.',
    'help.app.sec.l3': 'Konto MC możesz odłączyć w każdej chwili, wylogowując się ze strony Monsieur Cuisine.',
    'conv.safety': 'Sprawdź parametry przed wysłaniem. Autor nie ponosi odpowiedzialności za działanie przepisu na urządzeniu.',
    'conv.recipe_default': 'Przepis MC',
    'conv.difficulty_hard': 'Trudny',
    'conv.difficulty_medium': 'Średni',
    'conv.difficulty_easy': 'Łatwy',
    'conv.save_changes': 'Zapisz zmiany',
    'conv.editing': 'Edytujesz przepis',
    'conv.unsaved': 'niezapisane zmiany',
    'conv.edit': 'Edytuj',
    'conv.send_mc': 'Wyślij na MC',
    'conv.sending_mc': 'Wysyłanie…',
    'conv.sent_mc': 'Wysłano na MC',
    'conv.servings': 'porcje',
    'conv.steps_count': 'kroków',
    'conv.ingredients': 'Składniki',
    'conv.add': '+ Dodaj',
    'conv.steps_title': 'Kroki Monsieur Cuisine',
    'conv.step_title_ph': 'Tytuł kroku',
    'conv.step_desc_ph': 'Opis kroku',
    'conv.temp': 'Temp',
    'conv.speed': 'Pręd.',
    'conv.time': 'Czas',
    'conv.fix_selected': 'Popraw zaznaczone',
    'conv.fixing': 'Poprawiam...',
    'conv.fix_placeholder': 'Co jest nie tak? (opcjonalnie) np. brak pieczenia, zła temperatura...',
    'conv.fix_selected_label': 'Zaznaczono',
    'conv.fix_step': 'krok',
    'conv.fix_steps_few': 'kroki',
    'conv.fix_steps_many': 'kroków',
    'conv.fix_to_fix': 'do poprawy',
    'conv.nutrients': 'Wartości odżywcze (na porcję)',
    'conv.protein': 'Białko',
    'conv.carbs': 'Węgl.',
    'conv.fat': 'Tłuszcz',
    'conv.tips': 'Wskazówki:',
    'conv.ing_name_ph': 'Nazwa',
    'conv.ing_qty_ph': 'Ilość',

    // === SAVED RECIPES ===
    'saved.title': 'Zapisane przepisy',
    'saved.title_short': 'Zapisane',
    'saved.preview': 'Podgląd',
    'saved.load': 'Wczytaj',
    'saved.load_to_conv': 'Wczytaj do konwertera',
    'saved.open_mc': 'Otwórz na MC',
    'saved.no_data': 'Nie można wczytać danych przepisu.',
    'saved.select_all': 'Zaznacz wszystkie',
    'saved.pack_export': 'Eksportuj paczkę',
    'saved.pack_import': 'Importuj paczkę',
    'saved.pack_import_ok': 'Zaimportowano przepisów',
    'saved.pack_import_skipped': 'pominięto (błędny format)',
    'saved.bulk_send': 'Wyślij zaznaczone do MC',
    'saved.bulk_cancel': 'Anuluj',
    'saved.bulk_done': 'Wysyłka zakończona',
    'saved.bulk_ok': 'wysłano',
    'saved.bulk_no_payload': 'brak danych do wysyłki',
    'saved.fetch_photo': 'Pobierz zdjęcie z MC',
    'saved.bulk_fetch_photos': 'Pobierz zdjęcia',
    'saved.bulk_fetch_photos_hint': 'Zrób to PRZED skasowaniem przepisów z konta MC — zdjęcia znikają razem z nimi.',
    'saved.bulk_photos_done': 'Pobieranie zdjęć zakończone',
    'saved.bulk_photos_ok': 'pobrano',
    'saved.bulk_push_failed': 'Wysyłka nie powiodła się',

    // === EXTENSION MODAL ===
    'ext.title': 'Instalacja rozszerzenia Chrome',
    'ext.step1': 'Kliknij „Dodaj do Chrome" poniżej i zatwierdź instalację',
    'ext.step2': 'Zaloguj się na monsieur-cuisine.com w przeglądarce Chrome',
    'ext.step3': 'Wróć do MateMeal i odśwież stronę — pojawi się zielony status połączenia',
    'ext.security': 'Rozszerzenie pobiera wyłącznie ciasteczka sesji MC niezbędne do komunikacji z API. Żadne dane nie są przesyłane poza Twoją przeglądarkę.',
    'ext.banner_text': 'Zainstaluj Matemeal Connector — wysyłaj przepisy jednym kliknięciem na konto Monsieur Cuisine.',
    'ext.banner_cta': 'Dodaj do Chrome',
    'gate.noext_title': 'Brak wtyczki Matemeal Connector',
    'gate.noext_lead': 'Bez wtyczki MateMeal nie wyśle przepisu na Twoje konto Monsieur Cuisine — to ona przekazuje aplikacji Twoją sesję z monsieur-cuisine.com. Instalacja zajmuje minutę.',
    'gate.nosess_title': 'Brak aktywnej sesji Monsieur Cuisine',
    'gate.nosess_lead': 'Wtyczka działa, ale nie jesteś zalogowany na monsieur-cuisine.com w tej przeglądarce (albo sesja wygasła). Bez tego przepis nie trafi na Twoje konto MC.',
    'gate.nosess_step1': 'Otwórz monsieur-cuisine.com i zaloguj się na swoje konto',
    'gate.nosess_step2': 'Wróć na tę kartę — połączenie wykryje się samo, modal zniknie',
    'gate.nosess_cta': 'Otwórz monsieur-cuisine.com',
    'gate.nosess_bar': 'Wtyczka działa, ale brak sesji Monsieur Cuisine — zaloguj się na monsieur-cuisine.com',
    'gate.nosess_bar_link': 'jak to zrobić',
    'gate.convert_anyway': 'Konwertuj mimo to',
    'gate.later': 'Później',
    'gate.footnote': 'Konwersję i zapis przepisów w MateMeal możesz używać także bez połączenia, ale wysyłka na MC będzie niedostępna.',

    // === COOKIE BANNER ===
    'cookie.text': 'Ta aplikacja używa lokalnego przechowywania ciasteczek sesji Monsieur Cuisine wyłącznie w celu wysyłania przepisów na Twoje konto MC. Żadne dane nie są udostępniane podmiotom trzecim.',
    'cookie.accept': 'Rozumiem',
    'copyright.text': 'Konwertuj wyłącznie przepisy własne lub takie, z których korzystasz w ramach dozwolonego użytku osobistego (dyrektywa 2001/29/WE i prawo krajowe). MateMeal nie zachęca do kopiowania ani rozpowszechniania przepisów osób trzecich — za treści, które wysyłasz, odpowiadasz samodzielnie.',
    'copyright.accept': 'Rozumiem',

    // === HELP GUIDE ===
    'help.title': 'Jak używać MateMeal?',
    'help.tab.start': 'Jak zacząć?',
    'help.tab.extension': 'Rozszerzenie Chrome',
    'help.tab.convert': 'Konwersja przepisów',
    'help.tab.problems': 'Problemy?',

    'help.start.lead': 'MateMeal przekształca dowolny przepis na format Monsieur Cuisine Smart — z temperaturami, prędkościami i czasami. Możesz wysłać gotowy przepis jednym kliknięciem na swoje konto MC.',
    'help.start.h1': 'Trzy kroki do pierwszego przepisu',
    'help.start.s1.title': 'Utwórz konto i zaloguj się',
    'help.start.s1.desc_a': 'Kliknij',
    'help.start.s1.desc_strong': 'Zarejestruj',
    'help.start.s1.desc_b': 'w prawym górnym rogu. Konto jest potrzebne do zapisywania przepisów i synchronizacji z MC.',
    'help.start.s2.title': 'Wklej przepis i kliknij „Konwertuj na format MC"',
    'help.start.s2.desc': 'Wklej własny przepis albo napisz go własnymi słowami. AI doda wszystkie parametry maszyny.',
    'help.start.s3.title': 'Wyślij przepis na swoje konto Monsieur Cuisine',
    'help.start.s3.desc_a': 'Zainstaluj rozszerzenie Chrome (zakładka',
    'help.start.s3.desc_tab': 'Rozszerzenie Chrome',
    'help.start.s3.desc_b': '), zaloguj się na monsieur-cuisine.com i kliknij',
    'help.start.s3.desc_strong': 'Wyślij na MC',
    'help.start.alert': 'Rozszerzenie Chrome jest potrzebne do połączenia z kontem MC i wysyłania przepisów na urządzenie. Działa tylko na komputerze.',
    'help.start.h2': 'Co możesz wklejać?',
    'help.start.l1': 'Własne przepisy zapisane w dowolnej formie',
    'help.start.l2': 'Rodzinne przepisy z zeszytu (przepisane)',
    'help.start.l3': 'Inne przepisy wyłącznie w ramach dozwolonego użytku osobistego',
    'help.start.l4': 'Własny opis przepisu napisany w swoim języku',
    'help.start.l5': 'Składniki i kroki opisane dowolnie — AI sam rozezna strukturę',

    'help.ext.lead': 'Rozszerzenie Chrome łączy MateMeal z Twoim kontem Monsieur Cuisine. Po instalacji przepisy wysyłają się jednym kliknięciem — bez kopiowania i wklejania.',
    'help.ext.alert': 'Rozszerzenie Matemeal Connector jest dostępne w Chrome Web Store. Zainstaluj je jednym kliknięciem — żaden tryb programisty nie jest wymagany.',
    'help.ext.mobile.title': 'Korzystasz z telefonu?',
    'help.ext.mobile.desc_a': 'Chrome na Androidzie i iOS',
    'help.ext.mobile.desc_strong': 'nie obsługuje rozszerzeń',
    'help.ext.mobile.desc_b': '— na telefonie możesz:',
    'help.ext.mobile.l1_a': 'Konwertować przepisy',
    'help.ext.mobile.l1_strong': 'na MC Smart',
    'help.ext.mobile.l1_b': ' i zapisywać je w swoim profilu',
    'help.ext.mobile.l2': 'Wysyłanie przepisów na konto MC dostępne tylko na komputerze z rozszerzeniem Chrome',
    'help.ext.h1': 'Instalacja krok po kroku',
    'help.ext.s1.title': 'Znajdź folder rozszerzenia',
    'help.ext.s1.desc': 'W katalogu aplikacji MateMeal znajdź folder:',
    'help.ext.s2.title': 'Zainstaluj Matemeal Connector z Chrome Web Store',
    'help.ext.s2.desc_a': 'Kliknij link poniżej i zatwierdź instalację:',
    'help.ext.s2.desc_b': 'i naciśnij Enter.',
    'help.ext.s3.title': 'Włącz tryb programisty',
    'help.ext.s3.desc_a': 'W prawym górnym rogu strony chrome://extensions włącz przełącznik',
    'help.ext.s3.desc_strong': 'Tryb programisty',
    'help.ext.s3.desc_b': '(Developer mode).',
    'help.ext.s4.title': 'Załaduj rozpakowane rozszerzenie',
    'help.ext.s4.desc_a': 'Kliknij przycisk',
    'help.ext.s4.desc_strong': 'Załaduj rozpakowane',
    'help.ext.s4.desc_b': '(Load unpacked) i wskaż folder',
    'help.ext.s4.desc_c': '. Rozszerzenie pojawi się na liście jako MC Recipe Converter.',
    'help.ext.s5.title': 'Zaloguj się na Monsieur Cuisine',
    'help.ext.s5.desc': 'Otwórz monsieur-cuisine.com w nowej karcie i zaloguj się na swoje konto. To wystarczy — rozszerzenie automatycznie wykryje sesję.',
    'help.ext.s6.title': 'Wróć do MateMeal i odśwież stronę',
    'help.ext.s6.desc_a': 'Naciśnij',
    'help.ext.s6.desc_b': 'na stronie MateMeal. W konwerterze powinien pojawić się zielony komunikat',
    'help.ext.s6.desc_c': '„Połączono z Monsieur Cuisine".',
    'help.ext.ok_alert': 'Gotowe! Przy każdym uruchomieniu przeglądarki rozszerzenie automatycznie synchronizuje sesję — nie musisz nic powtarzać.',
    'help.ext.security.title': 'Bezpieczeństwo',
    'help.ext.security.l1': 'Rozszerzenie odczytuje wyłącznie ciasteczka sesji monsieur-cuisine.com',
    'help.ext.security.l2': 'Żadne dane nie są wysyłane do zewnętrznych serwerów poza MC i MateMeal',
    'help.ext.security.l3': 'Hasło do MC nigdy nie jest odczytywane ani przechowywane',

    'help.conv.lead': 'AI analizuje przepis i tłumaczy każdy krok na operacje Monsieur Cuisine Smart: ważenie składników, rozdrabnianie, podgrzewanie, gotowanie, blendowanie.',
    'help.conv.h1': 'Jak wkleić przepis?',
    'help.conv.l1': 'Zaznacz cały tekst swojego przepisu i skopiuj (Ctrl+C)',
    'help.conv.l2': 'Wklej (Ctrl+V) w pole tekstowe konwertera',
    'help.conv.l3_a': 'Kliknij',
    'help.conv.l3_strong': 'Konwertuj na format MC',
    'help.conv.h2': 'Co AI robi z przepisem?',
    'help.conv.card1.title': 'Ważenie',
    'help.conv.card1.desc': 'Każdy składnik trafia do oddzielnego kroku ważenia na wadze MC',
    'help.conv.card2.title': 'Temperatury',
    'help.conv.card2.desc': 'AI dobiera temperaturę do rodzaju operacji (smażenie, gotowanie, topienie)',
    'help.conv.card3.title': 'Prędkości',
    'help.conv.card3.desc': 'Prędkość miksowania zależy od konsystencji: siekanie 7-8, mieszanie 2-3',
    'help.conv.card4.title': 'Czasy',
    'help.conv.card4.desc': 'Czasy gotowania, miksowania i podgrzewania dobrane do typu potrawy',
    'help.conv.h3': 'Edycja i poprawianie',
    'help.conv.edit.l1_a': 'Kliknij',
    'help.conv.edit.l1_strong': 'Edytuj',
    'help.conv.edit.l1_b': 'aby zmienić tytuł, składniki lub opisy kroków',
    'help.conv.edit.l2_a': 'Zaznacz błędne kroki (checkbox przy każdym kroku) i kliknij',
    'help.conv.edit.l2_strong': 'Popraw zaznaczone',
    'help.conv.edit.l2_b': '— AI wygeneruje je od nowa',
    'help.conv.edit.l3': 'W trybie edycji możesz zmieniać kolejność kroków strzałkami ↑↓',
    'help.conv.h4': 'Co zrobić bez rozszerzenia?',
    'help.conv.share.l1_a': 'Przepis możesz',
    'help.conv.share.l1_strong': 'zapisać w koncie MateMeal',
    'help.conv.share.l1_b': '— kliknij ikonę zakładki obok przepisu',
    'help.conv.share.l2_a': 'Aby',
    'help.conv.share.l2_strong': 'wysłać przepis na urządzenie MC',
    'help.conv.share.l2_b': '— zainstaluj rozszerzenie Chrome (zakładka Rozszerzenie Chrome)',
    'help.conv.share.l3': 'Rozszerzenie jest bezpłatne i instaluje się jednym kliknięciem z Chrome Web Store',
    'help.conv.h5': 'Eksport, import i paczki przepisów',
    'help.conv.export.l1_a': 'Przy wyniku konwersji kliknij',
    'help.conv.export.l1_strong': '"Eksportuj przepis"',
    'help.conv.export.l1_b': 'żeby zapisać przepis jako plik — możesz go komuś wysłać, a on wczyta go z powrotem w matemeal (plik nie jest zwykłym tekstem do podglądania czy edytowania poza appką)',
    'help.conv.export.l2_a': 'W polu wgrywania kliknij',
    'help.conv.export.l2_strong': '"Importuj przepis"',
    'help.conv.export.l2_b': 'żeby wczytać taki plik od razu, bez udziału AI — gotowy do edycji lub wysyłki na MC',
    'help.conv.export.l3_a': 'W zakładce "Zapisane" zaznacz kilka przepisów i kliknij',
    'help.conv.export.l3_strong': '"Eksportuj paczkę"',
    'help.conv.export.l3_b': 'żeby wysłać komuś cały zestaw w jednym pliku',
    'help.conv.export.l4_a': 'Kliknij',
    'help.conv.export.l4_strong': '"Importuj paczkę"',
    'help.conv.export.l4_b': '— przepisy trafią prosto do Twojego przepiśnika, skąd zaznaczasz je i wysyłasz na MC jednym przyciskiem',
    'help.conv.export.l5': 'Jeśli przepis ma zapisane zdjęcie, jedzie razem z plikiem — u odbiorcy pojawi się automatycznie',
    'help.conv.alert': 'Zawsze sprawdź wygenerowany przepis przed użyciem na urządzeniu. AI stara się dobrać realistyczne parametry, ale przepis może wymagać drobnych korekt.',

    'help.prob.lead': 'Najczęstsze problemy i jak je rozwiązać.',
    'help.prob.h1': 'Problemy z rozszerzeniem',
    'help.prob.p1.q': '"Brak potwierdzenia z rozszerzenia"',
    'help.prob.p1.desc': 'Rozszerzenie nie odesłało wyniku na czas — albo serwer MC odpowiadał wolno (przepis mógł się mimo to utworzyć), albo kontekst rozszerzenia wygasł po jego aktualizacji lub przeładowaniu.',
    'help.prob.p1.l1': 'Najpierw sprawdź „Moje przepisy" na monsieur-cuisine.com — przepis bywa wysłany mimo komunikatu',
    'help.prob.p1.l2': 'Jeśli go tam nie ma — naciśnij F5 i wyślij ponownie',
    'help.prob.p1.l3_a': 'Jeśli problem wraca — przejdź do',
    'help.prob.p1.l3_b': ', kliknij ↻ (odśwież) przy rozszerzeniu Matemeal Connector, a następnie odśwież stronę',
    'help.prob.p2.q': '"Połączono z MC" nie pojawia się po instalacji rozszerzenia',
    'help.prob.p2.l1_a': 'Upewnij się, że jesteś zalogowany na',
    'help.prob.p2.l1_b': 'w tej samej przeglądarce',
    'help.prob.p2.l2': 'Odśwież stronę MateMeal (F5)',
    'help.prob.p2.l3': 'Jeśli nadal brak — przejdź do MC, wyloguj się i zaloguj ponownie, potem wróć do MateMeal i odśwież',
    'help.prob.p3.q': '"Token MC wygasł — zaloguj się ponownie"',
    'help.prob.p3.desc': 'Sesja Monsieur Cuisine wygasła (zazwyczaj po kilku dniach nieaktywności).',
    'help.prob.p3.l1': 'Otwórz monsieur-cuisine.com i zaloguj się ponownie',
    'help.prob.p3.l2': 'Wróć do MateMeal i odśwież stronę (F5)',
    'help.prob.p4.q': 'Jak przeinstalować rozszerzenie?',
    'help.prob.p4.l1_a': 'Otwórz',
    'help.prob.p4.l1_strong': 'chrome://extensions',
    'help.prob.p4.l1_b': 'i znajdź Matemeal Connector na liście',
    'help.prob.p4.l2_a': 'Kliknij',
    'help.prob.p4.l2_strong': 'Usuń',
    'help.prob.p4.l2_b': '— rozszerzenie zostanie odinstalowane',
    'help.prob.p4.l3': 'Zainstaluj ponownie z Chrome Web Store i zaloguj się na monsieur-cuisine.com',
    'help.prob.h2': 'Problemy z konwersją AI',
    'help.prob.p5.q': '"Błąd konwersji AI" / "Model przekroczył limit tokenów"',
    'help.prob.p5.desc': 'Przepis jest zbyt długi lub złożony dla modelu AI.',
    'help.prob.p5.l1': 'Spróbuj skrócić przepis — usuń zbędne wstępy i komentarze autora',
    'help.prob.p5.l2': 'Podziel przepis na dwie części i konwertuj każdą część osobno',
    'help.prob.p5.l3': 'Spróbuj ponownie za chwilę — może to tymczasowe przeciążenie API',
    'help.prob.p6.q': 'Wygenerowany przepis ma błędne kroki lub parametry',
    'help.prob.p6.l1': 'Zaznacz błędne kroki (checkbox przy każdym kroku)',
    'help.prob.p6.l2': 'Opcjonalnie wpisz co jest nie tak w polu notatki',
    'help.prob.p6.l3_a': 'Kliknij',
    'help.prob.p6.l3_strong': 'Popraw zaznaczone',
    'help.prob.p6.l3_b': '— AI wygeneruje te kroki od nowa',
    'help.prob.p6.l4_a': 'Jeśli efekt nadal nie jest dobry — użyj trybu',
    'help.prob.p6.l4_strong': 'Edytuj',
    'help.prob.p6.l4_b': 'i popraw ręcznie',
    'help.prob.p7.q': 'Składniki są niepoprawnie połączone lub brakuje kroków ważenia',
    'help.prob.p7.desc': 'AI czasem łączy kilka składników w jeden krok. W MC każdy składnik powinien być ważony osobno.',
    'help.prob.p7.l1': 'Zaznacz problematyczne kroki i kliknij Popraw zaznaczone',
    'help.prob.p7.l2': 'W notatce napisz np. „rozdziel składniki na oddzielne kroki ważenia"',
    'help.prob.h3': 'Inne',
    'help.prob.p8.q': 'Przepis został wysłany, ale nie widzę go na koncie MC',
    'help.prob.p8.l1': 'Sprawdź sekcję Moje przepisy na monsieur-cuisine.com',
    'help.prob.p8.l2': 'Odśwież stronę MC',
    'help.prob.p8.l3': 'Jeśli wysyłka zakończyła się sukcesem (zielony komunikat + link), przepis jest na koncie — może trzeba chwilę poczekać',
    'help.prob.p9.q': 'Mogę konwertować przepisy bez konta / bez rozszerzenia?',
    'help.prob.p9.desc': 'Konto jest wymagane do konwersji. Rozszerzenie Chrome jest potrzebne do połączenia konta MC i wysyłania przepisów — działa tylko na komputerze. Na telefonie możesz konwertować i zapisywać przepisy w profilu.',
    'help.prob.contact': 'Nie znalazłeś rozwiązania?',
    'contact.form.title': 'Napisz do nas',
    'contact.form.subject': 'Temat',
    'contact.form.subject.bug': 'Zgłoszenie błędu',
    'contact.form.subject.help': 'Pomoc',
    'contact.form.subject.other': 'Inne',
    'contact.form.message': 'Wiadomość',
    'contact.form.reply_email': 'Twój e-mail (opcjonalnie, do odpowiedzi)',
    'contact.form.send': 'Wyślij',
    'contact.form.sending': 'Wysyłanie…',
    'contact.form.success': 'Wiadomość wysłana! Odezwiemy się wkrótce.',
    'contact.form.error': 'Błąd wysyłania. Spróbuj ponownie za chwilę.',
    'contact.form.error_short': 'Błąd wysyłania. Spróbuj ponownie.',
    'contact.form.rate_limit': 'Zbyt wiele wiadomości. Spróbuj za godzinę.',

    // === CONVERTING MESSAGES ===
    converting_msgs: [
      'AI przeczytał „i smażyć aż gotowe" i przez chwilę długo milczał.',
      'Tłumaczę „na oko" na liczby. AI patrzy sceptycznie.',
      'Szukam definicji „trochę ciepłej wody". Baza danych milczy.',
      'Przeliczam „szklankę" — tę ze zlewu czy tę od babci do herbaty?',
      'AI właśnie odkrył, że polskie przepisy to bardziej sugestia niż instrukcja.',
      'Interpretuję „do smaku" jako wartość domyślną. AI kiwa głową niepewnie.',
      'Negocjuję temperaturę. Przepis mówi „gorący piekarnik". Definicja do ustalenia.',
      'Liczę ile to jest „spora garść". Mam małe ręce, przeliczam z marginesem.',
      'Sprawdzam, czy w przepisie nie ma ukrytego kroku „wyczuj intuicją".',
      'AI pyta ile to jest łyżka. Odpowiedź zależy od kucharza i jego nastroju.',
      'Uczę AI, że „podsmażyć chwilę" to może być 2 minuty albo 20 — jak się trafi.',
      'Robot kuchenny i AI ustalają, czyja wina, jeśli coś nie wyjdzie.',
      'Przeliczam szczypty. Przy „szczypta po szczycie" AI trochę się pogubił.',
      'Sprawdzam czy w przepisie nie napisano „dodaj ile trzeba". Napisano.',
      'AI skończył analizę i teraz przekonuje się do polskiej kuchni. Idzie mu.',
      'Tłumaczę przepis z zeszytu babci, gdzie co drugie słowo to „wiadomo jak".',
      'Szukam sensu w zdaniu „mieszać aż się połączy". Łączyć z czym dokładnie?',
      'Sprawdzam „duże jajka" — nie ma definicji, biorę średnią statystyczną.',
      'AI właśnie przeczytał krok „wyczuć odpowiedni moment". Trwa przetwarzanie.',
      'Przekonuję maszynę, że „aż się zrumieni" to nie jest komunikat o błędzie.',
      'Sprawdzam pojemność miski. Optymista z przepisu powiedział, że się zmieści.',
      'Tłumaczę „dużo miłości" — AI zaproponował 150 ml. Brzmi rozsądnie.',
      'AI natrafił na krok „doprowadzić do wrzenia" i pyta od której strony zacząć.',
      'Szukam granicy między „lekko podsmaż" a „przypal na wiór". Cienka linia.',
      'Krok „odstawić do ostygnięcia" — AI wpisał 4 godziny. Nikt nie protestuje.',
      'Przepis mówi „świeże składniki". AI otworzył Wikipedię i przeczytał wszystko o chlorofilu.',
      'Analizuję „garść pietruszki". Przez chwilę AI myślał, że to jednostka miary.',
      'AI próbuje ocenić czy „kremowa konsystencja" to 80% czy 85% gładkości.',
      'Krok „ugotować al dente" — AI właśnie uczył się włoskiego. Dosłownie.',
      'Napotykam „dopraw solą i pieprzem" — AI pyta ile to jest pieprzu. Dobre pytanie.',
      'Sprawdzam czy „patelnia rozgrzana do dymu" to norma czy wypadek.',
      'AI właśnie przeliczył 3 łyżki oliwy. Wynik: 45 ml. Przepis mówił „trochę".',
      'Tłumaczę „lekko ubij" — AI zaproponował dokładnie 37 uderzeń. Precyzja wzorowa.',
      'Robot kuchenny czeka. AI pisze instrukcję. Ktoś musi zacząć.',
      'Analiza składnika „woda" — AI sprawdza czy mineralna, kranowa, czy deszczowa.',
    ],
  },

  // ============================================================
  // ENGLISH
  // ============================================================
  en: {
    loading: 'Loading...',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    send: 'Send',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',

    'login.title': 'Sign In',
    'login.username': 'Email',
    'login.password': 'Password',
    'login.submit': 'Sign In',
    'login.no_account': "Don't have an account?",
    'login.register_link': 'Sign up',
    'login.forgot': 'Forgot password',
    'login.success': 'Signed in!',
    'login.error': 'Invalid credentials',

    'register.title': 'Create Account',
    'register.name': 'Full name',
    'register.email': 'Email',
    'register.password': 'Password',
    'register.confirm_password': 'Confirm password',
    'register.submit': 'Sign up',
    'register.has_account': 'Already have an account?',
    'register.login_link': 'Sign in',
    'register.success': 'Registration successful! You can now sign in.',
    'register.error': 'Registration failed.',
    'register.passwords_mismatch': 'Passwords do not match',

    'reset.title': 'Reset Password',
    'reset.intro': 'Enter the email address linked to your account. We will send a 6-digit code.',
    'reset.email_label': 'Email address',
    'reset.email_placeholder': 'your@email.com',
    'reset.sending': 'Sending...',
    'reset.send_code': 'Send code',
    'reset.code_sent': 'Code sent to',
    'reset.code_label': 'Code from email (6 digits)',
    'reset.new_password': 'New password',
    'reset.confirm_password': 'Confirm new password',
    'reset.confirm_placeholder': 'repeat password',
    'reset.min_chars': 'min. 6 characters',
    'reset.changing': 'Changing...',
    'reset.change': 'Change password',
    'reset.resend': 'Resend code',
    'reset.success': 'Password changed — you are now signed in!',
    'reset.passwords_mismatch': 'Passwords do not match',
    'reset.too_short': 'Password must be at least 6 characters',
    'reset.error_email': 'Error sending email',
    'reset.error_code': 'Code verification failed',

    'header.help': 'How to start?',
    'header.admin': 'Admin',
    'header.login': 'Sign In',
    'header.register': 'Sign Up',
    'header.logout_success': 'Signed out!',

    // === Account ===
    'account.title': 'My account',
    'account.username': 'Username',
    'account.email': 'Email',
    'account.logout': 'Sign out',
    'account.danger_title': 'Danger zone',
    'account.delete_desc': 'Permanently delete your account along with all saved recipes. This action cannot be undone.',
    'account.delete_btn': 'Delete account',
    'account.delete_warn': 'This action cannot be undone. All your data and saved recipes will be permanently deleted.',
    'account.delete_password_label': 'Confirm with password',
    'account.delete_confirm_btn': 'Delete account permanently',
    'account.deleting': 'Deleting...',
    'account.deleted': 'Your account has been deleted.',
    'account.delete_error': 'Failed to delete account.',

    'hero.title': 'Monsieur Cuisine Recipe Converter',
    'hero.sub': 'Paste your own recipe and AI will convert it to MC Smart format — with temperatures, times and speeds. Send it to your MC account with one click.',
    'hero.feat1': 'Paste your own recipe',
    'hero.feat2': 'AI converts to MC',
    'hero.feat3': 'Send to MC account',
    'hero.cta_login': 'Sign in and start',
    'hero.cta_help': 'How does it work?',

    'footer.tagline': 'Monsieur Cuisine Smart Recipe Converter',
    'footer.help': 'Help',
    'footer.contact': 'Contact',
    'footer.privacy': 'Privacy Policy',
    'footer.android': 'Android app',
    'app_update.text': 'A new version of the Matemeal app is available ({v}). Download it and install over the current one — no uninstalling needed.',
    'app_update.cta': 'Download',
    'footer.security': 'Safety:',
    'footer.security_text': 'Recipes are AI-generated. Always verify parameters before using on your device. The author bears no liability for any resulting damage.',
    'footer.affiliate': 'Affiliate disclaimer:',
    'footer.affiliate_text': 'This app contains affiliate links that support project development.',
    'footer.rights': 'All rights reserved.',

    'contact.tab_contact': 'Contact',
    'contact.tab_bug': 'Report a bug',
    'contact.intro_bug': 'Found a bug? Describe it below.',
    'contact.intro_contact': 'Have a question or suggestion? Write to us.',
    'contact.topic': 'Subject',
    'contact.email': 'Your e-mail',
    'contact.email_optional': '(optional)',
    'contact.message': 'Message',
    'contact.send': 'Send',
    'contact.sent_title': 'Message sent!',
    'contact.sent_text': 'We will get back to you soon.',
    'contact.bug_topic': 'Bug report',
    'contact.generic_topic': 'Message',

    'conv.title': 'Monsieur Cuisine Recipe Converter',
    'conv.title_short': 'Converter',
    'conv.sub': 'Paste your recipe — AI will convert it to MC Smart format',
    'conv.mc_connected': 'Connected to Monsieur Cuisine',
    'conv.mc_locale_title': 'MC account language (where recipes should be sent)',
    'conv.mc_connected_mobile': 'MC account connected',
    'conv.mobile_no_session': 'Converter works on mobile. Sending recipes to MC is available only on desktop with the Chrome extension.',
    'conv.mobile_hint': 'On mobile: convert the recipe, copy as Text and paste manually in the MC app — or use a computer to send with one click.',
    'conv.install_ext': 'To send recipes to your MC account — install the extension',
    'conv.url_label': 'Got a link to your own recipe? Import it from a URL',
    'conv.url_placeholder': 'e.g. https://...',
    'conv.url_btn': 'Import',
    'conv.url_loading': 'Fetching...',
    'conv.url_error': 'Could not import a recipe from this address',
    'conv.url_ok': 'Recipe imported — review the text below and click Convert',
    'conv.image_label': 'Got the recipe as a photo or screenshot? Read it in',
    'conv.image_btn': 'Upload photo / screenshot',
    'conv.image_loading': 'Reading text...',
    'conv.image_hint': 'You can also paste a screenshot (Ctrl+V) into the field below.',
    'conv.image_ok': 'Text extracted — review it below and click Convert',
    'conv.image_err': 'Could not read text from the image',
    'conv.dish_btn': 'Add dish photo',
    'conv.dish_loading': 'Uploading photo...',
    'conv.dish_ok': 'Photo ready — it will go to MC with the recipe',
    'conv.dish_remove': 'Remove',
    'conv.dish_hint': 'Optional. The photo becomes the recipe thumbnail on your MC account.',
    'conv.dish_err': 'Could not upload the photo — the recipe will be sent without a thumbnail',
    'conv.bg_waiting': 'Sending to MC — you can close this page, I will report back:',
    'conv.bg_done': 'Ready on MC:',
    'conv.paste_label': 'Paste your recipe in any form',
    'conv.paste_placeholder': `Paste your recipe or write it in your own words...

e.g.
'Tomato soup with basil
1 onion, 2 garlic cloves, 500g canned tomatoes, 500ml broth
Sauté onion and garlic in olive oil. Add tomatoes, broth, cook 20 min. Blend. Add basil.'`,
    'conv.limit_exhausted': 'Limit reached',
    'conv.limit_renews': 'renews',
    'conv.limit_usage': 'conversions this month',
    'conv.limit_left': 'remaining',
    'conv.converting': 'Converting...',
    'conv.convert_btn': 'Convert to MC format',
    'conv.reset': 'Start over',
    'conv.warning': 'Always verify the recipe before using on your device.',
    'conv.audit_fixed': 'Recipe audit: {n} issue(s) fixed automatically',
    'conv.error_empty': 'Please paste a recipe before converting.',
    'conv.error_conv': 'Conversion error',
    'conv.error_net': 'Network error',
    'conv.error_ext': 'No confirmation from the extension — the recipe may still have reached MC. Check "My recipes" on monsieur-cuisine.com before sending again.',
    'conv.error_send': 'Error sending to MC.',
    'conv.checking_mc': 'The extension timed out, but MC can be slow — checking whether the recipe was created anyway. Please keep this page open.',
    'conv.checking_srv': 'Sending in progress — Monsieur Cuisine servers take about 2 minutes to create a recipe. We are watching it for you: you can close this page, the link will be waiting when you return.',
    'conv.checking_mc_btn': 'Checking MC…',
    'conv.recovered': 'Sent! The extension reported a timeout, but the recipe is on your MC account.',
    'conv.error_no_mc_session': 'MC account not connected. Sign in on monsieur-cuisine.com on a computer with the Chrome extension installed.',
    'conv.error_mc_session_expired': 'Your Monsieur Cuisine session has expired. Sign in again on monsieur-cuisine.com and try sending the recipe again.',
    'conv.error_no_extension': 'The "Matemeal Connector" Chrome extension was not detected and no MC account is connected — there is no way to send the recipe. Install the extension or connect your MC account.',
    'conv.error_save': 'Error saving',
    'conv.error_load': 'Error loading recipe',
    'conv.saved_mc': 'Recipe saved to MC account!',
    'conv.sent_excl': 'Sent!',
    'conv.sent_draft': 'Sent to MC as a draft — add a dish photo on MC to publish it.',
    'conv.open_mc': 'Open recipe on MC',
    'conv.save': 'Save recipe',
    'conv.save_ok': 'Recipe saved to your cookbook!',
    'conv.export_json': 'Export recipe',
    'conv.import_json': 'Import recipe',
    'conv.import_json_ok': 'Recipe loaded from file!',
    'conv.import_json_err': "This isn't a matemeal recipe file — check that it's a valid export.",
    'conv.export_native_err': 'Could not save the file. Please try again.',
    'conv.json_import_label': 'Upload a recipe file',
    'conv.json_import_hint': "Loads a recipe previously exported from matemeal (📖 .mtmeal file) — no AI, ready to edit or send right away.",
    'conv.repair_hint': 'Optional: check a step with an error, describe the issue and click "Fix recipe". Steps with ⚖️ are MC scale steps — they have no machine parameters.',
    'conv.repair_placeholder': 'Describe what is wrong. E.g. "Step 4 is missing speed and time" or "Step 3 should be mixing at speed 5 for 30s"',
    'conv.repair_btn': 'Fix recipe',
    'conv.repairing': 'Fixing...',
    'conv.repair_ok': 'Recipe fixed!',
    'conv.repair_answer_placeholder': 'Your answer...',
    'conv.repair_send': 'Send',
    'conv.repair_cancel': 'Cancel',
    'conv.repair_save_ask': 'Save the repaired version?',
    'conv.repair_save_yes': 'Yes, save (replace previous)',
    'conv.repair_save_no': 'No, skip',
    'conv.step_weigh': 'MC Scale',
    'conv.step_manual': 'Manual',
    'conv.empty_hint1': 'Paste a recipe and click',
    'conv.empty_hint2': '"Convert to MC format"',
    'conv.empty_hint3': 'AI will adapt the recipe for the MC Smart device — adding temperatures, times and speeds.',
    'conv.empty_mc_note': 'To send recipes to your MC account, install the Chrome extension and sign in on monsieur-cuisine.com.',
    'conv.mc_connect_note': 'To send recipes to your MC account, connect the app to your Monsieur Cuisine account.',
    'conv.mc_connect_btn': 'Connect to Monsieur Cuisine',
    'conv.mc_connect_hint': 'Sign in to your Monsieur Cuisine account — the app will connect automatically.',
    'conv.mobile_no_session@app': 'MC account not connected — use the “Connect to Monsieur Cuisine” button to send recipes straight from the app.',
    'conv.image_hint@app': 'You can also take a photo of a recipe with your camera — the recognized text will appear in the field below.',
    'conv.error_ext@app': 'No sending confirmation — the recipe may still have reached MC. Check “My recipes” on monsieur-cuisine.com before sending again.',
    'conv.error_no_mc_session@app': 'MC account not connected. Tap “Connect to Monsieur Cuisine” in the converter and sign in to your account.',
    'conv.error_mc_session_expired@app': 'Your Monsieur Cuisine session has expired. Tap “Connect to Monsieur Cuisine”, sign in again and resend the recipe.',
    'help.start.s3.desc_a@app': 'Connect your Monsieur Cuisine account (see the',
    'help.start.s3.desc_tab@app': 'MC connection',
    'help.start.s3.desc_b@app': ' tab), then tap',
    'help.start.alert@app': 'You connect your MC account directly in the app — see the “MC connection” tab. No extensions, no computer needed.',
    'help.conv.l1@app': 'Copy the full text of your recipe',
    'help.conv.l2@app': 'Paste it into the converter field — or take a photo of the recipe with your camera',
    'help.conv.h4@app': 'Saving and sending',
    'help.conv.share.l2_b@app': '— connect your account in the “MC connection” tab',
    'help.conv.share.l3@app': 'You connect once — then you send recipes with a single tap',
    'help.prob.h1@app': 'MC connection issues',
    'help.prob.p3.l1@app': 'Tap “Connect to Monsieur Cuisine” in the converter and sign in again',
    'help.prob.p3.l2@app': 'Sending will be active again — the app refreshes the session in the background',
    'help.prob.p9.q@app': 'Can I convert recipes without an MC account?',
    'help.prob.p9.desc@app': 'A MateMeal account is required for conversion. To send recipes, connect your Monsieur Cuisine account in the app (see the “MC connection” tab).',
    'conv.image_camera': 'Take a photo',
    'help.tab.app': 'MC connection',
    'help.app.lead': 'In the app you don\'t need the Chrome extension — you connect your Monsieur Cuisine account directly in the app.',
    'help.app.alert': 'You connect only once. The app refreshes the session in the background.',
    'help.app.h1': 'How to connect your MC account',
    'help.app.s1.title': 'Sign in to Matemeal',
    'help.app.s1.desc': 'Use your regular Matemeal account — the same one as on the website.',
    'help.app.s2.title': 'Tap “Connect to Monsieur Cuisine”',
    'help.app.s2.desc': 'You\'ll find the button in the converter. A Monsieur Cuisine (Lidl account) sign-in window will open.',
    'help.app.s3.title': 'Sign in to your MC account',
    'help.app.s3.desc': 'After a successful sign-in the window closes automatically and recipe sending becomes active.',
    'help.app.note': 'Sending a recipe to your MC account usually takes about 2 minutes — you can keep using the app in the meantime.',
    'help.app.sec.l1': 'You enter your Lidl credentials only on the Monsieur Cuisine website — the app never sees or stores them.',
    'help.app.sec.l2': 'The app stores only the session (cookies), exactly like a browser.',
    'help.app.sec.l3': 'You can disconnect your MC account at any time by signing out of the Monsieur Cuisine website.',
    'conv.safety': 'Verify parameters before sending. The author bears no liability for recipe performance on the device.',
    'conv.recipe_default': 'MC Recipe',
    'conv.difficulty_hard': 'Hard',
    'conv.difficulty_medium': 'Medium',
    'conv.difficulty_easy': 'Easy',
    'conv.save_changes': 'Save changes',
    'conv.editing': 'Editing recipe',
    'conv.unsaved': 'unsaved changes',
    'conv.edit': 'Edit',
    'conv.send_mc': 'Send to MC',
    'conv.sending_mc': 'Sending…',
    'conv.sent_mc': 'Sent to MC',
    'conv.servings': 'servings',
    'conv.steps_count': 'steps',
    'conv.ingredients': 'Ingredients',
    'conv.add': '+ Add',
    'conv.steps_title': 'Monsieur Cuisine Steps',
    'conv.step_title_ph': 'Step title',
    'conv.step_desc_ph': 'Step description',
    'conv.temp': 'Temp',
    'conv.speed': 'Speed',
    'conv.time': 'Time',
    'conv.fix_selected': 'Fix selected',
    'conv.fixing': 'Fixing...',
    'conv.fix_placeholder': "What's wrong? (optional) e.g. missing baking step, wrong temperature...",
    'conv.fix_selected_label': 'Selected',
    'conv.fix_step': 'step',
    'conv.fix_steps_few': 'steps',
    'conv.fix_steps_many': 'steps',
    'conv.fix_to_fix': 'to fix',
    'conv.nutrients': 'Nutrition (per serving)',
    'conv.protein': 'Protein',
    'conv.carbs': 'Carbs',
    'conv.fat': 'Fat',
    'conv.tips': 'Tips:',
    'conv.ing_name_ph': 'Name',
    'conv.ing_qty_ph': 'Amount',

    'saved.title': 'Saved recipes',
    'saved.title_short': 'Saved',
    'saved.preview': 'Preview',
    'saved.load': 'Load',
    'saved.load_to_conv': 'Load into converter',
    'saved.open_mc': 'Open on MC',
    'saved.no_data': 'Cannot load recipe data.',
    'saved.select_all': 'Select all',
    'saved.pack_export': 'Export pack',
    'saved.pack_import': 'Import pack',
    'saved.pack_import_ok': 'Recipes imported',
    'saved.pack_import_skipped': 'skipped (invalid format)',
    'saved.bulk_send': 'Send selected to MC',
    'saved.bulk_cancel': 'Cancel',
    'saved.bulk_done': 'Sending finished',
    'saved.bulk_ok': 'sent',
    'saved.bulk_no_payload': 'no data to send',
    'saved.fetch_photo': 'Fetch photo from MC',
    'saved.bulk_fetch_photos': 'Fetch photos',
    'saved.bulk_fetch_photos_hint': 'Do this BEFORE deleting the recipes from your MC account — photos disappear with them.',
    'saved.bulk_photos_done': 'Photo fetching finished',
    'saved.bulk_photos_ok': 'fetched',
    'saved.bulk_push_failed': 'Sending failed',

    'ext.title': 'Chrome Extension Installation',
    'ext.step1': 'Click "Add to Chrome" below and confirm the installation',
    'ext.step2': 'Sign in on monsieur-cuisine.com in Chrome',
    'ext.step3': 'Return to MateMeal and refresh the page — a green connection status will appear',
    'ext.security': 'The extension only retrieves MC session cookies needed for API communication. No data is sent outside your browser.',
    'ext.banner_text': 'Install Matemeal Connector — send recipes to your Monsieur Cuisine account with one click.',
    'ext.banner_cta': 'Add to Chrome',
    'gate.noext_title': 'Matemeal Connector extension missing',
    'gate.noext_lead': 'Without the extension MateMeal cannot send recipes to your Monsieur Cuisine account — it is what passes your monsieur-cuisine.com session to the app. Installing takes a minute.',
    'gate.nosess_title': 'No active Monsieur Cuisine session',
    'gate.nosess_lead': 'The extension is working, but you are not signed in on monsieur-cuisine.com in this browser (or the session expired). Without it the recipe will not reach your MC account.',
    'gate.nosess_step1': 'Open monsieur-cuisine.com and sign in to your account',
    'gate.nosess_step2': 'Come back to this tab — the connection is detected automatically and this window closes',
    'gate.nosess_cta': 'Open monsieur-cuisine.com',
    'gate.nosess_bar': 'Extension is working, but there is no Monsieur Cuisine session — sign in on monsieur-cuisine.com',
    'gate.nosess_bar_link': 'how to',
    'gate.convert_anyway': 'Convert anyway',
    'gate.later': 'Later',
    'gate.footnote': 'You can still convert and save recipes in MateMeal without a connection, but sending to MC will not be available.',

    'cookie.text': 'This app uses local storage of Monsieur Cuisine session cookies solely to send recipes to your MC account. No data is shared with third parties.',
    'cookie.accept': 'Got it',
    'copyright.text': 'Convert only your own recipes or those you use within permitted private personal use (Directive 2001/29/EC and national law). MateMeal does not encourage copying or distributing third-party recipes — you are solely responsible for the content you submit.',
    'copyright.accept': 'Got it',

    'help.title': 'How to use MateMeal?',
    'help.tab.start': 'Getting started',
    'help.tab.extension': 'Chrome Extension',
    'help.tab.convert': 'Recipe conversion',
    'help.tab.problems': 'Problems?',

    'help.start.lead': 'MateMeal transforms any recipe into Monsieur Cuisine Smart format — with temperatures, speeds and times. You can send the finished recipe to your MC account with one click.',
    'help.start.h1': 'Three steps to your first recipe',
    'help.start.s1.title': 'Create an account and sign in',
    'help.start.s1.desc_a': 'Click',
    'help.start.s1.desc_strong': 'Sign up',
    'help.start.s1.desc_b': 'in the top right corner. An account is required to save recipes and sync with MC.',
    'help.start.s2.title': 'Paste a recipe and click "Convert to MC format"',
    'help.start.s2.desc': 'Paste your own recipe — or write it in your own words. AI will add all machine parameters.',
    'help.start.s3.title': 'Send the recipe to your Monsieur Cuisine account',
    'help.start.s3.desc_a': 'Install the Chrome extension (tab',
    'help.start.s3.desc_tab': 'Chrome Extension',
    'help.start.s3.desc_b': '), sign in on monsieur-cuisine.com and click',
    'help.start.s3.desc_strong': 'Send to MC',
    'help.start.alert': 'The Chrome extension is needed to connect your MC account and send recipes to your device. Works on desktop only.',
    'help.start.h2': 'What can you paste?',
    'help.start.l1': 'Your own recipes in any form',
    'help.start.l2': 'Family recipes from your notebook (typed out)',
    'help.start.l3': 'Other recipes only within permitted private personal use',
    'help.start.l4': 'Your own recipe description written in your language',
    'help.start.l5': 'Ingredients and steps described freely — AI will figure out the structure',

    'help.ext.lead': 'The Chrome extension connects MateMeal to your Monsieur Cuisine account. After installation, recipes are sent with one click — no copying and pasting.',
    'help.ext.alert': 'Matemeal Connector is available in the Chrome Web Store. Install it with one click — no developer mode required.',
    'help.ext.mobile.title': 'Using a phone?',
    'help.ext.mobile.desc_a': 'Chrome on Android and iOS',
    'help.ext.mobile.desc_strong': 'does not support extensions',
    'help.ext.mobile.desc_b': '— on mobile you can:',
    'help.ext.mobile.l1_a': 'Convert recipes',
    'help.ext.mobile.l1_strong': 'to MC Smart',
    'help.ext.mobile.l1_b': ' and save them to your profile',
    'help.ext.mobile.l2': 'Sending recipes to MC account is available only on desktop with the Chrome extension',
    'help.ext.h1': 'Step-by-step installation',
    'help.ext.s1.title': 'Find the extension folder',
    'help.ext.s1.desc': 'In the MateMeal app directory, find the folder:',
    'help.ext.s2.title': 'Install Matemeal Connector from Chrome Web Store',
    'help.ext.s2.desc_a': 'Click the link below and confirm the installation:',
    'help.ext.s2.desc_b': 'and press Enter.',
    'help.ext.s3.title': 'Enable Developer mode',
    'help.ext.s3.desc_a': 'In the top right corner of chrome://extensions, enable the',
    'help.ext.s3.desc_strong': 'Developer mode',
    'help.ext.s3.desc_b': 'toggle.',
    'help.ext.s4.title': 'Load the unpacked extension',
    'help.ext.s4.desc_a': 'Click',
    'help.ext.s4.desc_strong': 'Load unpacked',
    'help.ext.s4.desc_b': 'and point to the',
    'help.ext.s4.desc_c': 'folder. The extension will appear as MC Recipe Converter.',
    'help.ext.s5.title': 'Sign in to Monsieur Cuisine',
    'help.ext.s5.desc': 'Open monsieur-cuisine.com in a new tab and sign in to your account. That is enough — the extension will automatically detect the session.',
    'help.ext.s6.title': 'Return to MateMeal and refresh',
    'help.ext.s6.desc_a': 'Press',
    'help.ext.s6.desc_b': 'on the MateMeal page. The converter should show a green message',
    'help.ext.s6.desc_c': '"Connected to Monsieur Cuisine".',
    'help.ext.ok_alert': 'Done! Each time you launch the browser, the extension automatically syncs the session — no need to repeat anything.',
    'help.ext.security.title': 'Security',
    'help.ext.security.l1': 'The extension reads only monsieur-cuisine.com session cookies',
    'help.ext.security.l2': 'No data is sent to external servers other than MC and MateMeal',
    'help.ext.security.l3': 'Your MC password is never read or stored',

    'help.conv.lead': 'AI analyses the recipe and translates each step into Monsieur Cuisine Smart operations: weighing ingredients, chopping, heating, cooking, blending.',
    'help.conv.h1': 'How to paste a recipe?',
    'help.conv.l1': 'Select the entire text of your own recipe and copy (Ctrl+C)',
    'help.conv.l2': 'Paste (Ctrl+V) into the converter text field',
    'help.conv.l3_a': 'Click',
    'help.conv.l3_strong': 'Convert to MC format',
    'help.conv.h2': 'What does AI do with the recipe?',
    'help.conv.card1.title': 'Weighing',
    'help.conv.card1.desc': 'Each ingredient gets a separate weighing step on the MC scale',
    'help.conv.card2.title': 'Temperatures',
    'help.conv.card2.desc': 'AI selects temperature based on operation type (frying, boiling, melting)',
    'help.conv.card3.title': 'Speeds',
    'help.conv.card3.desc': 'Mixing speed depends on consistency: chopping 7-8, stirring 2-3',
    'help.conv.card4.title': 'Times',
    'help.conv.card4.desc': 'Cooking, mixing and heating times matched to the dish type',
    'help.conv.h3': 'Editing and fixing',
    'help.conv.edit.l1_a': 'Click',
    'help.conv.edit.l1_strong': 'Edit',
    'help.conv.edit.l1_b': 'to change the title, ingredients or step descriptions',
    'help.conv.edit.l2_a': 'Check faulty steps (checkbox next to each step) and click',
    'help.conv.edit.l2_strong': 'Fix selected',
    'help.conv.edit.l2_b': '— AI will regenerate them',
    'help.conv.edit.l3': 'In edit mode you can reorder steps using the ↑↓ arrows',
    'help.conv.h4': 'What to do without the extension?',
    'help.conv.share.l1_a': 'You can',
    'help.conv.share.l1_strong': 'save the recipe to your MateMeal account',
    'help.conv.share.l1_b': '— click the bookmark icon next to the recipe',
    'help.conv.share.l2_a': 'To',
    'help.conv.share.l2_strong': 'send the recipe to your MC device',
    'help.conv.share.l2_b': '— install the Chrome extension (Extension tab)',
    'help.conv.share.l3': 'The extension is free and installs with one click from the Chrome Web Store',
    'help.conv.h5': 'Export, import and recipe packs',
    'help.conv.export.l1_a': 'On the conversion result, click',
    'help.conv.export.l1_strong': '"Export recipe"',
    'help.conv.export.l1_b': "to save the recipe as a file — send it to someone and they can load it back into matemeal (it's not plain text you can view or edit outside the app)",
    'help.conv.export.l2_a': 'In the input area, click',
    'help.conv.export.l2_strong': '"Import recipe"',
    'help.conv.export.l2_b': 'to load such a file instantly, without AI — ready to edit or send to MC',
    'help.conv.export.l3_a': 'On the "Saved" tab, select several recipes and click',
    'help.conv.export.l3_strong': '"Export pack"',
    'help.conv.export.l3_b': 'to send someone a whole set in one file',
    'help.conv.export.l4_a': 'Click',
    'help.conv.export.l4_strong': '"Import pack"',
    'help.conv.export.l4_b': '— the recipes land straight in your cookbook, where you select them and send them to MC with one button',
    'help.conv.export.l5': "If a recipe has a saved photo, it travels with the file — it'll appear automatically for the recipient",
    'help.conv.alert': 'Always verify the generated recipe before using on your device. AI tries to choose realistic parameters, but the recipe may need minor adjustments.',

    'help.prob.lead': 'Common problems and how to fix them.',
    'help.prob.h1': 'Extension problems',
    'help.prob.p1.q': '"No confirmation from the extension"',
    'help.prob.p1.desc': 'The extension did not return a result in time — either the MC server was slow (the recipe may have been created anyway), or the extension context expired after an update or reload.',
    'help.prob.p1.l1': 'First check "My recipes" on monsieur-cuisine.com — the recipe is sometimes sent despite the message',
    'help.prob.p1.l2': 'If it is not there — press F5 and send again',
    'help.prob.p1.l3_a': 'If the problem persists — go to',
    'help.prob.p1.l3_b': ', click ↻ (reload) next to Matemeal Connector, then refresh the page',
    'help.prob.p2.q': '"Connected to MC" does not appear after installing the extension',
    'help.prob.p2.l1_a': 'Make sure you are signed in to',
    'help.prob.p2.l1_b': 'in the same browser',
    'help.prob.p2.l2': 'Refresh the MateMeal page (F5)',
    'help.prob.p2.l3': 'If still missing — go to MC, sign out and sign in again, then return to MateMeal and refresh',
    'help.prob.p3.q': '"MC token expired — please sign in again"',
    'help.prob.p3.desc': 'The Monsieur Cuisine session expired (usually after a few days of inactivity).',
    'help.prob.p3.l1': 'Open monsieur-cuisine.com and sign in again',
    'help.prob.p3.l2': 'Return to MateMeal and refresh the page (F5)',
    'help.prob.p4.q': 'How do I reinstall the extension?',
    'help.prob.p4.l1_a': 'Open',
    'help.prob.p4.l1_strong': 'chrome://extensions',
    'help.prob.p4.l1_b': 'and find Matemeal Connector on the list',
    'help.prob.p4.l2_a': 'Click',
    'help.prob.p4.l2_strong': 'Remove',
    'help.prob.p4.l2_b': '— the extension will be uninstalled',
    'help.prob.p4.l3': 'Reinstall from the Chrome Web Store and sign in on monsieur-cuisine.com',
    'help.prob.h2': 'AI conversion problems',
    'help.prob.p5.q': '"AI conversion error" / "Model exceeded token limit"',
    'help.prob.p5.desc': 'The recipe is too long or complex for the AI model.',
    'help.prob.p5.l1': 'Try shortening the recipe — remove unnecessary introductions and author comments',
    'help.prob.p5.l2': 'Split the recipe into two parts and convert each separately',
    'help.prob.p5.l3': 'Try again in a moment — it may be a temporary API overload',
    'help.prob.p6.q': 'The generated recipe has wrong steps or parameters',
    'help.prob.p6.l1': 'Check the faulty steps (checkbox next to each step)',
    'help.prob.p6.l2': 'Optionally type what is wrong in the notes field',
    'help.prob.p6.l3_a': 'Click',
    'help.prob.p6.l3_strong': 'Fix selected',
    'help.prob.p6.l3_b': '— AI will regenerate those steps',
    'help.prob.p6.l4_a': 'If still not good — use',
    'help.prob.p6.l4_strong': 'Edit',
    'help.prob.p6.l4_b': 'mode and fix manually',
    'help.prob.p7.q': 'Ingredients are incorrectly merged or weighing steps are missing',
    'help.prob.p7.desc': 'AI sometimes merges several ingredients into one step. In MC each ingredient should be weighed separately.',
    'help.prob.p7.l1': 'Check the problematic steps and click Fix selected',
    'help.prob.p7.l2': 'In the note write e.g. "split ingredients into separate weighing steps"',
    'help.prob.h3': 'Other',
    'help.prob.p8.q': 'Recipe was sent but I cannot see it on my MC account',
    'help.prob.p8.l1': 'Check the My Recipes section on monsieur-cuisine.com',
    'help.prob.p8.l2': 'Refresh the MC page',
    'help.prob.p8.l3': 'If the send succeeded (green message + link), the recipe is on the account — it may need a moment to sync',
    'help.prob.p9.q': 'Can I convert recipes without an account / without the extension?',
    'help.prob.p9.desc': 'An account is required for conversion. The Chrome extension is needed to connect your MC account and send recipes — desktop only. On mobile you can convert and save recipes to your profile.',
    'help.prob.contact': 'Did not find a solution?',
    'contact.form.title': 'Contact us',
    'contact.form.subject': 'Subject',
    'contact.form.subject.bug': 'Bug report',
    'contact.form.subject.help': 'Help',
    'contact.form.subject.other': 'Other',
    'contact.form.message': 'Message',
    'contact.form.reply_email': 'Your email (optional, for reply)',
    'contact.form.send': 'Send',
    'contact.form.sending': 'Sending…',
    'contact.form.success': 'Message sent! We will get back to you soon.',
    'contact.form.error': 'Send error. Please try again in a moment.',
    'contact.form.error_short': 'Send error. Please try again.',
    'contact.form.rate_limit': 'Too many messages. Try again in an hour.',

    converting_msgs: [
      'AI read "fry until done" and went quiet for a very long time.',
      'Translating "by eye" into numbers. AI looks skeptical.',
      'Looking up the definition of "a bit of warm water". Database is silent.',
      'Converting "a cup" — the measuring cup or grandma\'s teacup?',
      'AI just discovered that recipes are more of a suggestion than instructions.',
      'Interpreting "to taste" as a default value. AI nods uncertainly.',
      'Negotiating temperature. Recipe says "hot oven". Definition pending.',
      'Counting how much "a generous handful" is. I have small hands, adding margin.',
      'Checking if there\'s a hidden step "sense it intuitively".',
      'AI asks how big a tablespoon is. Answer depends on the cook\'s mood.',
      'Teaching AI that "sauté briefly" can be 2 minutes or 20 — as it happens.',
      'Kitchen machine and AI debating whose fault it is if something goes wrong.',
      'Converting pinches. At "a pinch upon a pinch" AI got a bit confused.',
      'Checking if the recipe says "add as much as needed". It does.',
      'AI finished the analysis and is warming up to home cooking. Going well.',
      'Translating from grandma\'s notebook where every other word is "you know how".',
      'Looking for meaning in "stir until combined". Combined with what, exactly?',
      'Checking "large eggs" — no definition found, taking statistical average.',
      'AI just read step "sense the right moment". Still processing.',
      'Convincing the machine that "until golden" is not an error message.',
      'Checking bowl capacity. The optimist who wrote the recipe said it would fit.',
      'Translating "lots of love" — AI suggested 150 ml. Sounds reasonable.',
      'AI encountered "bring to a rolling boil" and is researching what rolling means.',
      'Locating the line between "lightly browned" and "carbon". It\'s a fine one.',
      '"Let rest until cool" — AI entered 4 hours. Nobody objected.',
      'Recipe says "fresh ingredients". AI has been reading about chlorophyll for 3 minutes.',
      'Analysing "a handful of parsley". AI briefly thought it was a unit of measure.',
      'AI is trying to quantify "creamy texture". Current estimate: 83% smooth.',
      'Step says "cook al dente" — AI just looked up Italian. Literally.',
      '"Season with salt and pepper" — AI asks how much pepper. Valid question.',
      'Checking if "pan smoking hot" is intentional or a fire hazard.',
      'AI calculated 3 tablespoons of olive oil: 45 ml. Recipe said "a splash".',
      'Translating "beat lightly" — AI proposed exactly 37 strokes. Very precise.',
      'Kitchen machine is waiting. AI is writing instructions. Someone has to go first.',
      'Analysing ingredient "water" — AI checking: sparkling, still, or tap?',
    ],
  },

  // ============================================================
  // GERMAN
  // ============================================================
  de: {
    loading: 'Laden...',
    cancel: 'Abbrechen',
    save: 'Speichern',
    close: 'Schließen',
    send: 'Senden',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    back: 'Zurück',

    'login.title': 'Anmelden',
    'login.username': 'E-Mail',
    'login.password': 'Passwort',
    'login.submit': 'Anmelden',
    'login.no_account': 'Kein Konto?',
    'login.register_link': 'Registrieren',
    'login.forgot': 'Passwort vergessen',
    'login.success': 'Angemeldet!',
    'login.error': 'Ungültige Anmeldedaten',

    'register.title': 'Konto erstellen',
    'register.name': 'Vor- und Nachname',
    'register.email': 'E-Mail',
    'register.password': 'Passwort',
    'register.confirm_password': 'Passwort bestätigen',
    'register.submit': 'Registrieren',
    'register.has_account': 'Bereits ein Konto?',
    'register.login_link': 'Anmelden',
    'register.success': 'Registrierung erfolgreich! Sie können sich jetzt anmelden.',
    'register.error': 'Registrierung fehlgeschlagen.',
    'register.passwords_mismatch': 'Passwörter stimmen nicht überein',

    'reset.title': 'Passwort zurücksetzen',
    'reset.intro': 'Geben Sie die mit Ihrem Konto verknüpfte E-Mail-Adresse ein. Wir senden einen 6-stelligen Code.',
    'reset.email_label': 'E-Mail-Adresse',
    'reset.email_placeholder': 'ihre@email.de',
    'reset.sending': 'Wird gesendet...',
    'reset.send_code': 'Code senden',
    'reset.code_sent': 'Code gesendet an',
    'reset.code_label': 'Code aus der E-Mail (6 Ziffern)',
    'reset.new_password': 'Neues Passwort',
    'reset.confirm_password': 'Neues Passwort bestätigen',
    'reset.confirm_placeholder': 'Passwort wiederholen',
    'reset.min_chars': 'mind. 6 Zeichen',
    'reset.changing': 'Wird geändert...',
    'reset.change': 'Passwort ändern',
    'reset.resend': 'Code erneut senden',
    'reset.success': 'Passwort geändert — Sie sind jetzt angemeldet!',
    'reset.passwords_mismatch': 'Passwörter stimmen nicht überein',
    'reset.too_short': 'Das Passwort muss mindestens 6 Zeichen lang sein',
    'reset.error_email': 'Fehler beim Senden der E-Mail',
    'reset.error_code': 'Code-Verifizierung fehlgeschlagen',

    'header.help': 'Wie anfangen?',
    'header.admin': 'Admin',
    'header.login': 'Anmelden',
    'header.register': 'Registrieren',
    'header.logout_success': 'Abgemeldet!',

    // === Konto ===
    'account.title': 'Mein Konto',
    'account.username': 'Benutzername',
    'account.email': 'E-Mail',
    'account.logout': 'Abmelden',
    'account.danger_title': 'Gefahrenzone',
    'account.delete_desc': 'Konto und alle gespeicherten Rezepte dauerhaft löschen. Diese Aktion kann nicht rückgängig gemacht werden.',
    'account.delete_btn': 'Konto löschen',
    'account.delete_warn': 'Diese Aktion kann nicht rückgängig gemacht werden. Alle Ihre Daten und gespeicherten Rezepte werden dauerhaft gelöscht.',
    'account.delete_password_label': 'Mit Passwort bestätigen',
    'account.delete_confirm_btn': 'Konto endgültig löschen',
    'account.deleting': 'Wird gelöscht...',
    'account.deleted': 'Ihr Konto wurde gelöscht.',
    'account.delete_error': 'Konto konnte nicht gelöscht werden.',

    'hero.title': 'Monsieur Cuisine Rezeptkonverter',
    'hero.sub': 'Eigenes Rezept einfügen — die KI wandelt es in das MC Smart-Format um — mit Temperaturen, Zeiten und Geschwindigkeiten. Das fertige Rezept mit einem Klick auf Ihr Konto senden.',
    'hero.feat1': 'Eigenes Rezept einfügen',
    'hero.feat2': 'KI konvertiert zu MC',
    'hero.feat3': 'Ans MC-Konto senden',
    'hero.cta_login': 'Anmelden und starten',
    'hero.cta_help': 'Wie funktioniert es?',

    'footer.tagline': 'Monsieur Cuisine Smart Rezeptkonverter',
    'footer.help': 'Hilfe',
    'footer.contact': 'Kontakt',
    'footer.privacy': 'Datenschutzerklärung',
    'footer.android': 'Android-App',
    'app_update.text': 'Eine neue Version der Matemeal-App ist verfügbar ({v}). Herunterladen und über die aktuelle installieren — ohne Deinstallation.',
    'app_update.cta': 'Herunterladen',
    'footer.security': 'Sicherheit:',
    'footer.security_text': 'Rezepte werden von einer KI generiert. Überprüfen Sie immer die Parameter, bevor Sie das Gerät verwenden. Der Autor haftet nicht für etwaige Schäden.',
    'footer.affiliate': 'Affiliate-Hinweis:',
    'footer.affiliate_text': 'Diese App enthält Partnerlinks, die die Projektentwicklung unterstützen.',
    'footer.rights': 'Alle Rechte vorbehalten.',

    'contact.tab_contact': 'Kontakt',
    'contact.tab_bug': 'Fehler melden',
    'contact.intro_bug': 'Einen Fehler gefunden? Beschreiben Sie ihn unten.',
    'contact.intro_contact': 'Haben Sie eine Frage oder einen Vorschlag? Schreiben Sie uns.',
    'contact.topic': 'Betreff',
    'contact.email': 'Ihre E-Mail',
    'contact.email_optional': '(optional)',
    'contact.message': 'Nachricht',
    'contact.send': 'Senden',
    'contact.sent_title': 'Nachricht gesendet!',
    'contact.sent_text': 'Wir melden uns bald.',
    'contact.bug_topic': 'Fehlermeldung',
    'contact.generic_topic': 'Nachricht',

    'conv.title': 'Monsieur Cuisine Rezeptkonverter',
    'conv.title_short': 'Konverter',
    'conv.sub': 'Eigenes Rezept einfügen — die KI wandelt es ins MC Smart-Format um',
    'conv.mc_connected': 'Verbunden mit Monsieur Cuisine',
    'conv.mc_locale_title': 'MC-Konto-Sprache (wohin Rezepte gesendet werden)',
    'conv.mc_connected_mobile': 'MC-Konto verbunden',
    'conv.mobile_no_session': 'Konverter funktioniert auf dem Handy. Rezepte an MC senden nur am Computer mit Chrome-Erweiterung möglich.',
    'conv.mobile_hint': 'Auf dem Handy: Rezept konvertieren, als Text kopieren und manuell in der MC-App einfügen — oder am Computer mit einem Klick senden.',
    'conv.install_ext': 'Um Rezepte ans MC-Konto zu senden — Erweiterung installieren',
    'conv.url_label': 'Link zu Ihrem eigenen Rezept? Per URL importieren',
    'conv.url_placeholder': 'z. B. https://...',
    'conv.url_btn': 'Importieren',
    'conv.url_loading': 'Lade...',
    'conv.url_error': 'Rezept konnte von dieser Adresse nicht importiert werden',
    'conv.url_ok': 'Rezept importiert — Text unten prüfen und auf Konvertieren klicken',
    'conv.image_label': 'Rezept als Foto oder Screenshot? Hier einlesen',
    'conv.image_btn': 'Foto / Screenshot hochladen',
    'conv.image_loading': 'Text wird gelesen...',
    'conv.image_hint': 'Sie können auch einen Screenshot (Strg+V) in das Feld unten einfügen.',
    'conv.image_ok': 'Text erkannt — unten prüfen und auf Konvertieren klicken',
    'conv.image_err': 'Text konnte aus dem Bild nicht gelesen werden',
    'conv.dish_btn': 'Foto des Gerichts hinzufügen',
    'conv.dish_loading': 'Foto wird hochgeladen...',
    'conv.dish_ok': 'Foto bereit — es geht mit dem Rezept an MC',
    'conv.dish_remove': 'Entfernen',
    'conv.dish_hint': 'Optional. Das Foto wird zum Rezept-Thumbnail in Ihrem MC-Konto.',
    'conv.dish_err': 'Foto konnte nicht hochgeladen werden — Rezept wird ohne Thumbnail gesendet',
    'conv.bg_waiting': 'Wird an MC gesendet — Sie können die Seite schließen:',
    'conv.bg_done': 'Fertig auf MC:',
    'conv.paste_label': 'Rezept in beliebiger Form einfügen',
    'conv.paste_placeholder': `Eigenes Rezept einfügen oder in eigenen Worten schreiben...

z.B.
'Tomatensuppe mit Basilikum
1 Zwiebel, 2 Knoblauchzehen, 500g Dosentomaten, 500ml Brühe
Zwiebel und Knoblauch in Olivenöl anschwitzen. Tomaten, Brühe dazugeben, 20 Min. kochen. Mixen. Basilikum hinzufügen.'`,
    'conv.limit_exhausted': 'Limit erreicht',
    'conv.limit_renews': 'erneuert sich',
    'conv.limit_usage': 'Konvertierungen diesen Monat',
    'conv.limit_left': 'verbleibend',
    'conv.converting': 'Konvertiere...',
    'conv.convert_btn': 'In MC-Format konvertieren',
    'conv.reset': 'Neu beginnen',
    'conv.warning': 'Überprüfen Sie das Rezept immer vor der Verwendung am Gerät.',
    'conv.audit_fixed': 'Rezept-Audit: {n} Punkt(e) automatisch korrigiert',
    'conv.error_empty': 'Bitte fügen Sie ein Rezept ein, bevor Sie konvertieren.',
    'conv.error_conv': 'Konvertierungsfehler',
    'conv.error_net': 'Netzwerkfehler',
    'conv.error_ext': 'Keine Bestätigung von der Erweiterung — das Rezept wurde möglicherweise trotzdem an MC gesendet. Prüfe „Meine Rezepte" auf monsieur-cuisine.com, bevor du es erneut sendest.',
    'conv.error_send': 'Fehler beim Senden an MC.',
    'conv.checking_mc': 'Die Erweiterung hat das Zeitlimit überschritten, aber MC kann langsam sein — ich prüfe, ob das Rezept trotzdem erstellt wurde. Bitte Seite offen lassen.',
    'conv.checking_srv': 'Senden läuft — die Monsieur-Cuisine-Server brauchen ca. 2 Minuten zum Erstellen des Rezepts. Wir behalten es im Blick: Sie können die Seite schließen, der Link wartet nach Ihrer Rückkehr.',
    'conv.checking_mc_btn': 'Prüfe MC…',
    'conv.recovered': 'Gesendet! Die Erweiterung meldete eine Zeitüberschreitung, aber das Rezept ist auf deinem MC-Konto.',
    'conv.error_no_mc_session': 'MC-Konto nicht verbunden. Melden Sie sich auf monsieur-cuisine.com an einem Computer mit der Chrome-Erweiterung an.',
    'conv.error_mc_session_expired': 'Ihre Monsieur-Cuisine-Sitzung ist abgelaufen. Melden Sie sich erneut auf monsieur-cuisine.com an und versuchen Sie es noch einmal.',
    'conv.error_no_extension': 'Die Chrome-Erweiterung „Matemeal Connector" wurde nicht erkannt und kein MC-Konto ist verbunden — das Rezept kann nicht gesendet werden. Installieren Sie die Erweiterung oder verbinden Sie Ihr MC-Konto.',
    'conv.error_save': 'Fehler beim Speichern',
    'conv.error_load': 'Fehler beim Laden des Rezepts',
    'conv.saved_mc': 'Rezept auf MC-Konto gespeichert!',
    'conv.sent_excl': 'Gesendet!',
    'conv.sent_draft': 'Als Entwurf an MC gesendet — Foto des Gerichts auf MC hinzufügen, um zu veröffentlichen.',
    'conv.open_mc': 'Rezept auf MC öffnen',
    'conv.save': 'Rezept speichern',
    'conv.save_ok': 'Rezept im Kochbuch gespeichert!',
    'conv.export_json': 'Rezept exportieren',
    'conv.import_json': 'Rezept importieren',
    'conv.import_json_ok': 'Rezept aus Datei geladen!',
    'conv.import_json_err': 'Das ist keine matemeal-Rezeptdatei — bitte gültigen Export prüfen.',
    'conv.export_native_err': 'Datei konnte nicht gespeichert werden. Bitte erneut versuchen.',
    'conv.json_import_label': 'Rezeptdatei hochladen',
    'conv.json_import_hint': 'Lädt ein zuvor aus matemeal exportiertes Rezept (📖 .mtmeal-Datei) — ohne KI, sofort bereit zum Bearbeiten oder Senden.',
    'conv.repair_hint': 'Optional: Schritt mit Fehler ankreuzen, Problem beschreiben, "Rezept korrigieren" klicken. Schritte mit ⚖️ sind MC-Wiegeschritte — sie haben keine Maschinenparameter.',
    'conv.repair_placeholder': 'Beschreibe das Problem. Z.B. "Schritt 4 fehlt Geschwindigkeit und Zeit" oder "Schritt 3 soll Mixen bei Stufe 5 für 30s sein"',
    'conv.repair_btn': 'Rezept korrigieren',
    'conv.repairing': 'Korrigiere...',
    'conv.repair_ok': 'Rezept korrigiert!',
    'conv.repair_answer_placeholder': 'Deine Antwort...',
    'conv.repair_send': 'Senden',
    'conv.repair_cancel': 'Abbrechen',
    'conv.repair_save_ask': 'Korrigierte Version speichern?',
    'conv.repair_save_yes': 'Ja, speichern (vorherige ersetzen)',
    'conv.repair_save_no': 'Nein, überspringen',
    'conv.step_weigh': 'MC-Waage',
    'conv.step_manual': 'Manuell',
    'conv.empty_hint1': 'Rezept einfügen und klicken',
    'conv.empty_hint2': '"In MC-Format konvertieren"',
    'conv.empty_hint3': 'Die KI passt das Rezept an das MC Smart-Gerät an — fügt Temperaturen, Zeiten und Geschwindigkeiten hinzu.',
    'conv.empty_mc_note': 'Um Rezepte ans MC-Konto zu senden, installieren Sie die Chrome-Erweiterung und melden Sie sich auf monsieur-cuisine.com an.',
    'conv.mc_connect_note': 'Um Rezepte ans MC-Konto zu senden, verbinden Sie die App mit Ihrem Monsieur-Cuisine-Konto.',
    'conv.mc_connect_btn': 'Mit Monsieur Cuisine verbinden',
    'conv.mc_connect_hint': 'Melden Sie sich bei Ihrem Monsieur-Cuisine-Konto an — die App verbindet sich automatisch.',
    'conv.mobile_no_session@app': 'MC-Konto nicht verbunden — nutzen Sie die Schaltfläche „Mit Monsieur Cuisine verbinden”, um Rezepte direkt aus der App zu senden.',
    'conv.image_hint@app': 'Sie können ein Rezept auch mit der Kamera fotografieren — der erkannte Text erscheint im Feld unten.',
    'conv.error_ext@app': 'Keine Sendebestätigung — das Rezept kann trotzdem bei MC angekommen sein. Prüfen Sie „Meine Rezepte” auf monsieur-cuisine.com, bevor Sie erneut senden.',
    'conv.error_no_mc_session@app': 'MC-Konto nicht verbunden. Tippen Sie im Konverter auf „Mit Monsieur Cuisine verbinden” und melden Sie sich an.',
    'conv.error_mc_session_expired@app': 'Ihre Monsieur-Cuisine-Sitzung ist abgelaufen. Tippen Sie auf „Mit Monsieur Cuisine verbinden”, melden Sie sich erneut an und senden Sie das Rezept noch einmal.',
    'help.start.s3.desc_a@app': 'Verbinden Sie Ihr Monsieur-Cuisine-Konto (Tab',
    'help.start.s3.desc_tab@app': 'MC-Verbindung',
    'help.start.s3.desc_b@app': '), dann tippen Sie auf',
    'help.start.alert@app': 'Ihr MC-Konto verbinden Sie direkt in der App — siehe Tab „MC-Verbindung”. Ohne Erweiterungen, ohne Computer.',
    'help.conv.l1@app': 'Kopieren Sie den vollständigen Text Ihres Rezepts',
    'help.conv.l2@app': 'Fügen Sie ihn ins Konverterfeld ein — oder fotografieren Sie das Rezept mit der Kamera',
    'help.conv.h4@app': 'Speichern und Senden',
    'help.conv.share.l2_b@app': '— verbinden Sie Ihr Konto im Tab „MC-Verbindung”',
    'help.conv.share.l3@app': 'Sie verbinden einmal — danach senden Sie Rezepte mit einem Tipp',
    'help.prob.h1@app': 'Probleme mit der MC-Verbindung',
    'help.prob.p3.l1@app': 'Tippen Sie im Konverter auf „Mit Monsieur Cuisine verbinden” und melden Sie sich erneut an',
    'help.prob.p3.l2@app': 'Das Senden ist wieder aktiv — die App aktualisiert die Sitzung im Hintergrund',
    'help.prob.p9.q@app': 'Kann ich Rezepte ohne MC-Konto konvertieren?',
    'help.prob.p9.desc@app': 'Ein MateMeal-Konto ist für die Konvertierung erforderlich. Zum Senden von Rezepten verbinden Sie Ihr Monsieur-Cuisine-Konto in der App (Tab „MC-Verbindung”).',
    'conv.image_camera': 'Foto aufnehmen',
    'help.tab.app': 'MC-Verbindung',
    'help.app.lead': 'In der App brauchen Sie keine Chrome-Erweiterung — Sie verbinden Ihr Monsieur-Cuisine-Konto direkt in der App.',
    'help.app.alert': 'Die Verbindung erfolgt nur einmal. Die App aktualisiert die Sitzung im Hintergrund.',
    'help.app.h1': 'So verbinden Sie Ihr MC-Konto',
    'help.app.s1.title': 'Bei Matemeal anmelden',
    'help.app.s1.desc': 'Verwenden Sie Ihr normales Matemeal-Konto — dasselbe wie auf der Website.',
    'help.app.s2.title': '„Mit Monsieur Cuisine verbinden” antippen',
    'help.app.s2.desc': 'Die Schaltfläche finden Sie im Konverter. Es öffnet sich ein Anmeldefenster von Monsieur Cuisine (Lidl-Konto).',
    'help.app.s3.title': 'Beim MC-Konto anmelden',
    'help.app.s3.desc': 'Nach erfolgreicher Anmeldung schließt sich das Fenster automatisch und das Senden von Rezepten ist aktiv.',
    'help.app.note': 'Das Senden eines Rezepts ans MC-Konto dauert in der Regel etwa 2 Minuten — Sie können die App währenddessen normal nutzen.',
    'help.app.sec.l1': 'Ihre Lidl-Zugangsdaten geben Sie ausschließlich auf der Monsieur-Cuisine-Website ein — die App sieht und speichert sie nicht.',
    'help.app.sec.l2': 'Die App speichert nur die Sitzung (Cookies), genau wie ein Browser.',
    'help.app.sec.l3': 'Sie können Ihr MC-Konto jederzeit trennen, indem Sie sich von der Monsieur-Cuisine-Website abmelden.',
    'conv.safety': 'Parameter vor dem Senden prüfen. Der Autor haftet nicht für das Verhalten des Rezepts am Gerät.',
    'conv.recipe_default': 'MC-Rezept',
    'conv.difficulty_hard': 'Schwer',
    'conv.difficulty_medium': 'Mittel',
    'conv.difficulty_easy': 'Einfach',
    'conv.save_changes': 'Änderungen speichern',
    'conv.editing': 'Rezept bearbeiten',
    'conv.unsaved': 'nicht gespeicherte Änderungen',
    'conv.edit': 'Bearbeiten',
    'conv.send_mc': 'An MC senden',
    'conv.sending_mc': 'Wird gesendet…',
    'conv.sent_mc': 'An MC gesendet',
    'conv.servings': 'Portionen',
    'conv.steps_count': 'Schritte',
    'conv.ingredients': 'Zutaten',
    'conv.add': '+ Hinzufügen',
    'conv.steps_title': 'Monsieur Cuisine Schritte',
    'conv.step_title_ph': 'Schritttitel',
    'conv.step_desc_ph': 'Schrittbeschreibung',
    'conv.temp': 'Temp.',
    'conv.speed': 'Geschw.',
    'conv.time': 'Zeit',
    'conv.fix_selected': 'Ausgewählte korrigieren',
    'conv.fixing': 'Korrigiere...',
    'conv.fix_placeholder': 'Was stimmt nicht? (optional) z.B. fehlender Backschritt, falsche Temperatur...',
    'conv.fix_selected_label': 'Ausgewählt',
    'conv.fix_step': 'Schritt',
    'conv.fix_steps_few': 'Schritte',
    'conv.fix_steps_many': 'Schritte',
    'conv.fix_to_fix': 'zu korrigieren',
    'conv.nutrients': 'Nährwerte (pro Portion)',
    'conv.protein': 'Eiweiß',
    'conv.carbs': 'Kohlenhydr.',
    'conv.fat': 'Fett',
    'conv.tips': 'Tipps:',
    'conv.ing_name_ph': 'Name',
    'conv.ing_qty_ph': 'Menge',

    'saved.title': 'Gespeicherte Rezepte',
    'saved.title_short': 'Gespeichert',
    'saved.preview': 'Vorschau',
    'saved.load': 'Laden',
    'saved.load_to_conv': 'In Konverter laden',
    'saved.open_mc': 'Auf MC öffnen',
    'saved.no_data': 'Rezeptdaten konnten nicht geladen werden.',
    'saved.select_all': 'Alle auswählen',
    'saved.pack_export': 'Paket exportieren',
    'saved.pack_import': 'Paket importieren',
    'saved.pack_import_ok': 'Rezepte importiert',
    'saved.pack_import_skipped': 'übersprungen (ungültiges Format)',
    'saved.bulk_send': 'Ausgewählte an MC senden',
    'saved.bulk_cancel': 'Abbrechen',
    'saved.bulk_done': 'Versand abgeschlossen',
    'saved.bulk_ok': 'gesendet',
    'saved.bulk_no_payload': 'keine Daten zum Senden',
    'saved.fetch_photo': 'Foto von MC abrufen',
    'saved.bulk_fetch_photos': 'Fotos abrufen',
    'saved.bulk_fetch_photos_hint': 'Mach das VOR dem Löschen der Rezepte im MC-Konto — Fotos verschwinden mit ihnen.',
    'saved.bulk_photos_done': 'Fotoabruf abgeschlossen',
    'saved.bulk_photos_ok': 'abgerufen',
    'saved.bulk_push_failed': 'Senden fehlgeschlagen',

    'ext.title': 'Chrome-Erweiterung installieren',
    'ext.step1': 'Klicke unten auf „Zu Chrome hinzufügen" und bestätige die Installation',
    'ext.step2': 'Melde dich auf monsieur-cuisine.com in Chrome an',
    'ext.step3': 'Kehre zu MateMeal zurück und lade die Seite neu — der grüne Verbindungsstatus erscheint',
    'ext.security': 'Die Erweiterung ruft ausschließlich die für die API-Kommunikation erforderlichen MC-Sitzungscookies ab. Es werden keine Daten außerhalb Ihres Browsers übertragen.',
    'ext.banner_text': 'Instaliere Matemeal Connector — sende Rezepte mit einem Klick an dein Monsieur Cuisine-Konto.',
    'ext.banner_cta': 'Zu Chrome hinzufügen',
    'gate.noext_title': 'Erweiterung Matemeal Connector fehlt',
    'gate.noext_lead': 'Ohne die Erweiterung kann MateMeal keine Rezepte an Ihr Monsieur-Cuisine-Konto senden — sie übergibt der App Ihre Sitzung von monsieur-cuisine.com. Die Installation dauert eine Minute.',
    'gate.nosess_title': 'Keine aktive Monsieur-Cuisine-Sitzung',
    'gate.nosess_lead': 'Die Erweiterung funktioniert, aber Sie sind in diesem Browser nicht auf monsieur-cuisine.com angemeldet (oder die Sitzung ist abgelaufen). Ohne Anmeldung gelangt das Rezept nicht in Ihr MC-Konto.',
    'gate.nosess_step1': 'Öffnen Sie monsieur-cuisine.com und melden Sie sich an',
    'gate.nosess_step2': 'Kehren Sie zu diesem Tab zurück — die Verbindung wird automatisch erkannt und das Fenster schließt sich',
    'gate.nosess_cta': 'monsieur-cuisine.com öffnen',
    'gate.nosess_bar': 'Erweiterung funktioniert, aber keine Monsieur-Cuisine-Sitzung — melden Sie sich auf monsieur-cuisine.com an',
    'gate.nosess_bar_link': 'so geht’s',
    'gate.convert_anyway': 'Trotzdem konvertieren',
    'gate.later': 'Später',
    'gate.footnote': 'Rezepte konvertieren und speichern können Sie in MateMeal auch ohne Verbindung, das Senden an MC ist dann aber nicht möglich.',

    'cookie.text': 'Diese App verwendet lokalen Speicher für Monsieur Cuisine-Sitzungscookies ausschließlich zum Senden von Rezepten an Ihr MC-Konto. Es werden keine Daten an Dritte weitergegeben.',
    'cookie.accept': 'Verstanden',
    'copyright.text': 'Konvertieren Sie nur eigene Rezepte oder solche, die Sie im Rahmen der erlaubten Privatnutzung verwenden (Richtlinie 2001/29/EG und nationales Recht). MateMeal ermutigt nicht zum Kopieren oder Verbreiten von Rezepten Dritter — für übermittelte Inhalte sind Sie selbst verantwortlich.',
    'copyright.accept': 'Verstanden',

    'help.title': 'Wie benutze ich MateMeal?',
    'help.tab.start': 'Erste Schritte',
    'help.tab.extension': 'Chrome-Erweiterung',
    'help.tab.convert': 'Rezeptkonvertierung',
    'help.tab.problems': 'Probleme?',

    'help.start.lead': 'MateMeal wandelt beliebige Rezepte in das Monsieur Cuisine Smart-Format um — mit Temperaturen, Geschwindigkeiten und Zeiten. Das fertige Rezept können Sie mit einem Klick an Ihr MC-Konto senden.',
    'help.start.h1': 'Drei Schritte zum ersten Rezept',
    'help.start.s1.title': 'Konto erstellen und anmelden',
    'help.start.s1.desc_a': 'Klicken Sie auf',
    'help.start.s1.desc_strong': 'Registrieren',
    'help.start.s1.desc_b': 'oben rechts. Ein Konto ist zum Speichern von Rezepten und zur Synchronisierung mit MC erforderlich.',
    'help.start.s2.title': 'Rezept einfügen und auf „In MC-Format konvertieren" klicken',
    'help.start.s2.desc': 'Eigenes Rezept einfügen — oder in eigenen Worten schreiben. Die KI fügt alle Geräteparameter hinzu.',
    'help.start.s3.title': 'Rezept an Ihr Monsieur Cuisine-Konto senden',
    'help.start.s3.desc_a': 'Installieren Sie die Chrome-Erweiterung (Registerkarte',
    'help.start.s3.desc_tab': 'Chrome-Erweiterung',
    'help.start.s3.desc_b': '), melden Sie sich auf monsieur-cuisine.com an und klicken Sie auf',
    'help.start.s3.desc_strong': 'An MC senden',
    'help.start.alert': 'Die Chrome-Erweiterung wird benötigt, um das MC-Konto zu verbinden und Rezepte zu senden. Funktioniert nur am Computer.',
    'help.start.h2': 'Was können Sie einfügen?',
    'help.start.l1': 'Eigene Rezepte in beliebiger Form',
    'help.start.l2': 'Familienrezepte aus dem Notizbuch (abgetippt)',
    'help.start.l3': 'Andere Rezepte nur im Rahmen der erlaubten Privatnutzung',
    'help.start.l4': 'Eigene Rezeptbeschreibung in Ihrer Sprache',
    'help.start.l5': 'Zutaten und Schritte frei beschrieben — die KI erkennt die Struktur selbst',

    'help.ext.lead': 'Die Chrome-Erweiterung verbindet MateMeal mit Ihrem Monsieur Cuisine-Konto. Nach der Installation werden Rezepte mit einem Klick gesendet — ohne Kopieren und Einfügen.',
    'help.ext.alert': 'Matemeal Connector ist im Chrome Web Store verfügbar. Mit einem Klick installieren — kein Entwicklermodus erforderlich.',
    'help.ext.mobile.title': 'Nutzen Sie ein Smartphone?',
    'help.ext.mobile.desc_a': 'Chrome auf Android und iOS',
    'help.ext.mobile.desc_strong': 'unterstützt keine Erweiterungen',
    'help.ext.mobile.desc_b': '— auf dem Smartphone können Sie:',
    'help.ext.mobile.l1_a': 'Rezepte umwandeln',
    'help.ext.mobile.l1_strong': 'für MC Smart',
    'help.ext.mobile.l1_b': ' und im Profil speichern',
    'help.ext.mobile.l2': 'Rezepte an MC senden nur am Computer mit Chrome-Erweiterung möglich',
    'help.ext.h1': 'Schritt-für-Schritt-Installation',
    'help.ext.s1.title': 'Erweiterungsordner finden',
    'help.ext.s1.desc': 'Im MateMeal-App-Verzeichnis den Ordner finden:',
    'help.ext.s2.title': 'Matemeal Connector aus dem Chrome Web Store installieren',
    'help.ext.s2.desc_a': 'Klicke auf den Link unten und bestätige die Installation:',
    'help.ext.s2.desc_b': 'und Enter drücken.',
    'help.ext.s3.title': 'Entwicklermodus aktivieren',
    'help.ext.s3.desc_a': 'Oben rechts auf der Seite chrome://extensions den Schalter',
    'help.ext.s3.desc_strong': 'Entwicklermodus',
    'help.ext.s3.desc_b': '(Developer mode) aktivieren.',
    'help.ext.s4.title': 'Entpackte Erweiterung laden',
    'help.ext.s4.desc_a': 'Auf die Schaltfläche',
    'help.ext.s4.desc_strong': 'Entpackte Erweiterung laden',
    'help.ext.s4.desc_b': 'klicken und den Ordner',
    'help.ext.s4.desc_c': 'auswählen. Die Erweiterung erscheint als MC Recipe Converter.',
    'help.ext.s5.title': 'Bei Monsieur Cuisine anmelden',
    'help.ext.s5.desc': 'monsieur-cuisine.com in einem neuen Tab öffnen und am Konto anmelden. Das reicht — die Erweiterung erkennt die Sitzung automatisch.',
    'help.ext.s6.title': 'Zu MateMeal zurückkehren und Seite aktualisieren',
    'help.ext.s6.desc_a': 'Drücken Sie',
    'help.ext.s6.desc_b': 'auf der MateMeal-Seite. Im Konverter sollte eine grüne Meldung erscheinen',
    'help.ext.s6.desc_c': '"Verbunden mit Monsieur Cuisine".',
    'help.ext.ok_alert': 'Fertig! Bei jedem Browserstart synchronisiert die Erweiterung die Sitzung automatisch — Sie müssen nichts wiederholen.',
    'help.ext.security.title': 'Sicherheit',
    'help.ext.security.l1': 'Die Erweiterung liest ausschließlich monsieur-cuisine.com-Sitzungscookies',
    'help.ext.security.l2': 'Es werden keine Daten an externe Server außer MC und MateMeal gesendet',
    'help.ext.security.l3': 'Ihr MC-Passwort wird niemals gelesen oder gespeichert',

    'help.conv.lead': 'Die KI analysiert das Rezept und übersetzt jeden Schritt in Monsieur Cuisine Smart-Operationen: Zutaten abwiegen, zerkleinern, erhitzen, kochen, mixen.',
    'help.conv.h1': 'Wie füge ich ein Rezept ein?',
    'help.conv.l1': 'Den gesamten Text Ihres eigenen Rezepts markieren und kopieren (Strg+C)',
    'help.conv.l2': 'In das Textfeld des Konverters einfügen (Strg+V)',
    'help.conv.l3_a': 'Klicken Sie auf',
    'help.conv.l3_strong': 'In MC-Format konvertieren',
    'help.conv.h2': 'Was macht die KI mit dem Rezept?',
    'help.conv.card1.title': 'Wiegen',
    'help.conv.card1.desc': 'Jede Zutat erhält einen eigenen Wiegeschritt auf der MC-Waage',
    'help.conv.card2.title': 'Temperaturen',
    'help.conv.card2.desc': 'Die KI wählt die Temperatur je nach Vorgangsart (Braten, Kochen, Schmelzen)',
    'help.conv.card3.title': 'Geschwindigkeiten',
    'help.conv.card3.desc': 'Mixgeschwindigkeit je nach Konsistenz: Hacken 7-8, Rühren 2-3',
    'help.conv.card4.title': 'Zeiten',
    'help.conv.card4.desc': 'Koch-, Mix- und Heizzeiten passend zum Gerichttyp',
    'help.conv.h3': 'Bearbeiten und korrigieren',
    'help.conv.edit.l1_a': 'Klicken Sie auf',
    'help.conv.edit.l1_strong': 'Bearbeiten',
    'help.conv.edit.l1_b': 'um Titel, Zutaten oder Schrittbeschreibungen zu ändern',
    'help.conv.edit.l2_a': 'Fehlerhafte Schritte markieren (Checkbox neben jedem Schritt) und auf',
    'help.conv.edit.l2_strong': 'Ausgewählte korrigieren',
    'help.conv.edit.l2_b': 'klicken — die KI generiert sie neu',
    'help.conv.edit.l3': 'Im Bearbeitungsmodus können Sie Schritte mit ↑↓ neu anordnen',
    'help.conv.h4': 'Was tun ohne die Erweiterung?',
    'help.conv.share.l1_a': 'Das Rezept kann',
    'help.conv.share.l1_strong': 'im MateMeal-Konto gespeichert werden',
    'help.conv.share.l1_b': '— auf das Lesezeichen-Symbol neben dem Rezept klicken',
    'help.conv.share.l2_a': 'Um',
    'help.conv.share.l2_strong': 'das Rezept ans MC-Gerät zu senden',
    'help.conv.share.l2_b': '— Chrome-Erweiterung installieren (Tab „Erweiterung")',
    'help.conv.share.l3': 'Die Erweiterung ist kostenlos und lässt sich mit einem Klick aus dem Chrome Web Store installieren',
    'help.conv.h5': 'Export, Import und Rezeptpakete',
    'help.conv.export.l1_a': 'Klicken Sie beim Konvertierungsergebnis auf',
    'help.conv.export.l1_strong': '"Rezept exportieren"',
    'help.conv.export.l1_b': 'um das Rezept als Datei zu speichern — Sie können sie jemandem schicken, der sie in matemeal wieder lädt (kein reiner Text, der außerhalb der App angezeigt oder bearbeitet werden kann)',
    'help.conv.export.l2_a': 'Klicken Sie im Eingabebereich auf',
    'help.conv.export.l2_strong': '"Rezept importieren"',
    'help.conv.export.l2_b': 'um so eine Datei sofort zu laden, ohne KI — bereit zum Bearbeiten oder Senden ans MC',
    'help.conv.export.l3_a': 'Wählen Sie im Tab "Gespeichert" mehrere Rezepte aus und klicken Sie auf',
    'help.conv.export.l3_strong': '"Paket exportieren"',
    'help.conv.export.l3_b': 'um jemandem ein ganzes Set in einer Datei zu schicken',
    'help.conv.export.l4_a': 'Klicken Sie auf',
    'help.conv.export.l4_strong': '"Paket importieren"',
    'help.conv.export.l4_b': '— die Rezepte landen direkt in Ihrem Kochbuch, von wo Sie sie auswählen und mit einem Klick ans MC senden',
    'help.conv.export.l5': 'Falls ein Rezept ein gespeichertes Foto hat, reist es mit der Datei mit — es erscheint automatisch beim Empfänger',
    'help.conv.alert': 'Überprüfen Sie das generierte Rezept immer vor der Verwendung am Gerät. Die KI versucht realistische Parameter zu wählen, aber das Rezept kann kleinere Anpassungen erfordern.',

    'help.prob.lead': 'Häufige Probleme und wie man sie löst.',
    'help.prob.h1': 'Probleme mit der Erweiterung',
    'help.prob.p1.q': '"Keine Bestätigung von der Erweiterung"',
    'help.prob.p1.desc': 'Die Erweiterung hat das Ergebnis nicht rechtzeitig zurückgemeldet — entweder antwortete der MC-Server langsam (das Rezept wurde möglicherweise trotzdem erstellt), oder der Erweiterungskontext ist nach einem Update oder Neuladen abgelaufen.',
    'help.prob.p1.l1': 'Prüfe zuerst „Meine Rezepte" auf monsieur-cuisine.com — das Rezept wird manchmal trotz der Meldung gesendet',
    'help.prob.p1.l2': 'Falls es dort nicht ist — F5 drücken und erneut senden',
    'help.prob.p1.l3_a': 'Falls das Problem anhält — zu',
    'help.prob.p1.l3_b': 'gehen, ↻ (Neu laden) neben Matemeal Connector klicken, dann Seite aktualisieren',
    'help.prob.p2.q': '"Verbunden mit MC" erscheint nach Installation der Erweiterung nicht',
    'help.prob.p2.l1_a': 'Sicherstellen, dass Sie bei',
    'help.prob.p2.l1_b': 'im selben Browser angemeldet sind',
    'help.prob.p2.l2': 'MateMeal-Seite aktualisieren (F5)',
    'help.prob.p2.l3': 'Falls noch nicht vorhanden — zu MC gehen, ab- und wieder anmelden, dann zu MateMeal zurückkehren und aktualisieren',
    'help.prob.p3.q': '"MC-Token abgelaufen — bitte erneut anmelden"',
    'help.prob.p3.desc': 'Die Monsieur Cuisine-Sitzung ist abgelaufen (in der Regel nach einigen Tagen Inaktivität).',
    'help.prob.p3.l1': 'monsieur-cuisine.com öffnen und erneut anmelden',
    'help.prob.p3.l2': 'Zu MateMeal zurückkehren und Seite aktualisieren (F5)',
    'help.prob.p4.q': 'Wie installiere ich die Erweiterung neu?',
    'help.prob.p4.l1_a': 'Öffne',
    'help.prob.p4.l1_strong': 'chrome://extensions',
    'help.prob.p4.l1_b': 'und finde Matemeal Connector in der Liste',
    'help.prob.p4.l2_a': 'Klicke auf',
    'help.prob.p4.l2_strong': 'Entfernen',
    'help.prob.p4.l2_b': '— die Erweiterung wird deinstalliert',
    'help.prob.p4.l3': 'Installiere die Erweiterung erneut aus dem Chrome Web Store und melde dich auf monsieur-cuisine.com an',
    'help.prob.h2': 'KI-Konvertierungsprobleme',
    'help.prob.p5.q': '"KI-Konvertierungsfehler" / "Modell hat Token-Limit überschritten"',
    'help.prob.p5.desc': 'Das Rezept ist zu lang oder zu komplex für das KI-Modell.',
    'help.prob.p5.l1': 'Rezept kürzen — unnötige Einleitungen und Autorenkommentare entfernen',
    'help.prob.p5.l2': 'Rezept in zwei Teile aufteilen und jeden Teil separat konvertieren',
    'help.prob.p5.l3': 'Nach einer kurzen Pause erneut versuchen — möglicherweise temporäre API-Überlastung',
    'help.prob.p6.q': 'Das generierte Rezept hat falsche Schritte oder Parameter',
    'help.prob.p6.l1': 'Fehlerhafte Schritte markieren (Checkbox neben jedem Schritt)',
    'help.prob.p6.l2': 'Optional im Notizfeld beschreiben, was nicht stimmt',
    'help.prob.p6.l3_a': 'Auf',
    'help.prob.p6.l3_strong': 'Ausgewählte korrigieren',
    'help.prob.p6.l3_b': 'klicken — die KI generiert diese Schritte neu',
    'help.prob.p6.l4_a': 'Falls immer noch nicht gut — den',
    'help.prob.p6.l4_strong': 'Bearbeiten',
    'help.prob.p6.l4_b': '-Modus nutzen und manuell korrigieren',
    'help.prob.p7.q': 'Zutaten werden falsch zusammengefasst oder Wiegeschritte fehlen',
    'help.prob.p7.desc': 'Die KI fasst manchmal mehrere Zutaten in einem Schritt zusammen. In MC sollte jede Zutat einzeln gewogen werden.',
    'help.prob.p7.l1': 'Problematische Schritte markieren und auf Ausgewählte korrigieren klicken',
    'help.prob.p7.l2': 'Im Notizfeld z.B. schreiben: „Zutaten in separate Wiegeschritte aufteilen"',
    'help.prob.h3': 'Sonstiges',
    'help.prob.p8.q': 'Rezept wurde gesendet, aber ich sehe es nicht auf meinem MC-Konto',
    'help.prob.p8.l1': 'Den Bereich Meine Rezepte auf monsieur-cuisine.com prüfen',
    'help.prob.p8.l2': 'MC-Seite aktualisieren',
    'help.prob.p8.l3': 'Falls das Senden erfolgreich war (grüne Meldung + Link), ist das Rezept auf dem Konto — es kann einen Moment dauern bis zur Synchronisierung',
    'help.prob.p9.q': 'Kann ich Rezepte ohne Konto / ohne Erweiterung konvertieren?',
    'help.prob.p9.desc': 'Ein Konto ist für die Konvertierung erforderlich. Die Chrome-Erweiterung wird nur für die erste MC-Kontoverbindung benötigt — nach der Verbindung am Computer können Sie Rezepte von jedem Gerät senden, auch vom Smartphone.',
    'help.prob.contact': 'Keine Lösung gefunden?',
    'contact.form.title': 'Schreib uns',
    'contact.form.subject': 'Betreff',
    'contact.form.subject.bug': 'Fehlermeldung',
    'contact.form.subject.help': 'Hilfe',
    'contact.form.subject.other': 'Sonstiges',
    'contact.form.message': 'Nachricht',
    'contact.form.reply_email': 'Deine E-Mail (optional, für Antworten)',
    'contact.form.send': 'Senden',
    'contact.form.sending': 'Wird gesendet…',
    'contact.form.success': 'Nachricht gesendet! Wir melden uns in Kürze.',
    'contact.form.error': 'Sendefehler. Bitte versuche es gleich erneut.',
    'contact.form.error_short': 'Sendefehler. Bitte versuche es erneut.',
    'contact.form.rate_limit': 'Zu viele Nachrichten. Bitte warte eine Stunde.',

    converting_msgs: [
      'KI las „braten bis fertig" und schwieg danach sehr lange.',
      'Übersetze „nach Augenmaß" in Zahlen. KI schaut skeptisch.',
      'Suche Definition von „etwas warmes Wasser". Datenbank schweigt.',
      'Konvertiere „eine Tasse" — den Messbecher oder Omas Teetasse?',
      'KI hat gerade festgestellt, dass Rezepte eher Vorschläge als Anweisungen sind.',
      'Interpretiere „nach Geschmack" als Standardwert. KI nickt unsicher.',
      'Verhandlung über Temperatur. Rezept sagt „heißer Ofen". Definition ausstehend.',
      'Messe „eine großzügige Handvoll". Ich habe kleine Hände, rechne großzügig.',
      'Prüfe ob das Rezept einen versteckten Schritt „intuitiv erspüren" hat.',
      'KI fragt, wie groß ein Esslöffel ist. Antwort hängt vom Koch ab.',
      'Bringe KI bei, dass „kurz anbraten" 2 oder 20 Minuten bedeuten kann.',
      'Küchenmaschine und KI diskutieren, wessen Schuld es ist, falls etwas schiefgeht.',
      'Konvertiere Prisen. Bei „eine Prise nach der anderen" hat KI etwas gerechnet.',
      'Prüfe ob das Rezept sagt „so viel wie nötig". Tut es.',
      'KI hat die Analyse abgeschlossen und erwärmt sich für die Hausmannskost. Läuft.',
      'Übersetze aus Omas Notizbuch, wo jedes zweite Wort „wie immer" ist.',
      'Suche Sinn in „rühren bis alles verbunden ist". Verbunden womit genau?',
      'Prüfe „große Eier" — keine Definition gefunden, nehme statistischen Durchschnitt.',
      'KI las gerade Schritt „den richtigen Moment erspüren". Verarbeitung läuft.',
      'Überzeuge die Maschine, dass „bis goldbraun" keine Fehlermeldung ist.',
      'Prüfe Schüsselkapazität. Der Optimist der das Rezept schrieb meinte, es passt.',
      'Übersetze „viel Liebe" — KI schlug 150 ml vor. Klingt vernünftig.',
      'KI stieß auf „zum Kochen bringen" und fragt: Kochen wovon genau?',
      'Suche die Grenze zwischen „leicht angebräunt" und „Kohle". Sie ist sehr schmal.',
      '„Abkühlen lassen" — KI trug 4 Stunden ein. Niemand widersprach.',
      'Rezept sagt „frische Zutaten". KI liest seit 3 Minuten über Photosynthese.',
      'Analysiere „eine Handvoll Petersilie". KI dachte kurz, es sei eine Maßeinheit.',
      'KI versucht „cremige Konsistenz" zu quantifizieren. Aktuelle Schätzung: 83 % glatt.',
      'Schritt: „al dente kochen" — KI hat gerade Italienisch gelernt. Wörtlich.',
      '„Mit Salz und Pfeffer abschmecken" — KI fragt wie viel Pfeffer. Gute Frage.',
      'Prüfe ob „Pfanne rauchend heiß" Absicht oder Brandalarm ist.',
      'KI berechnete 3 Esslöffel Olivenöl: 45 ml. Rezept sagte „einen Schuss".',
      'Übersetze „leicht schlagen" — KI schlug genau 37 Mal vor. Sehr präzise.',
      'Küchenmaschine wartet. KI schreibt Anleitung. Einer muss anfangen.',
      'Analysiere Zutat „Wasser" — KI prüft: Sprudel, still oder Leitungswasser?',
    ],
  },
};

// Map known backend Polish error messages to translation keys
const ERROR_MAP = {
  'Nieprawidłowe hasło': { en: 'Invalid password', de: 'Falsches Passwort' },
  'Użytkownik nie istnieje': { en: 'User does not exist', de: 'Benutzer existiert nicht' },
  'Nazwa użytkownika jest już zajęta': { en: 'Username is already taken', de: 'Benutzername ist bereits vergeben' },
  'Email jest już zajęty': { en: 'Email is already taken', de: 'E-Mail ist bereits vergeben' },
  'Konto zablokowane': { en: 'Account is blocked', de: 'Konto ist gesperrt' },
  'Konto zablokowane przez administratora': { en: 'Account blocked by administrator', de: 'Konto vom Administrator gesperrt' },
  'Hasło musi mieć co najmniej 6 znaków': { en: 'Password must be at least 6 characters', de: 'Passwort muss mindestens 6 Zeichen lang sein' },
  'Hasła nie są identyczne': { en: 'Passwords do not match', de: 'Passwörter stimmen nicht überein' },
  'Nie znaleziono konta z tym adresem email': { en: 'No account found with this email address', de: 'Kein Konto mit dieser E-Mail-Adresse gefunden' },
  'Nieprawidłowy lub wygasły kod': { en: 'Invalid or expired code', de: 'Ungültiger oder abgelaufener Code' },
  'Wymagane są nazwa użytkownika i hasło': { en: 'Username and password are required', de: 'Benutzername und Passwort sind erforderlich' },
  'Rejestracja nie powiodła się': { en: 'Registration failed', de: 'Registrierung fehlgeschlagen' },
  'Limit konwersji wyczerpany': { en: 'Conversion limit reached', de: 'Konvertierungslimit erreicht' },
  'Błąd konwersji': { en: 'Conversion error', de: 'Konvertierungsfehler' },
  'Błąd sieci': { en: 'Network error', de: 'Netzwerkfehler' },
  'Obecne hasło jest nieprawidłowe': { en: 'Current password is incorrect', de: 'Aktuelles Passwort ist falsch' },
  'Wymagane jest hasło': { en: 'Password is required', de: 'Passwort ist erforderlich' },
};

export function translateError(msg, lang) {
  if (!msg || lang === 'pl') return msg;
  for (const [pl, translations] of Object.entries(ERROR_MAP)) {
    if (msg.includes(pl)) return msg.replace(pl, translations[lang] || pl);
  }
  return msg;
}
